<template>
    <section class="tables new-updated-design add-property-wrap">
        <vue-snotify></vue-snotify>
        <!-- Add loading overlay -->
        <div v-if="isLoading" class="loading-overlay">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">{{ $t('common.loading') }}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-12">
                <div class="left-card m-b-30">
                    <div class="Customer-card-body">
                        <div v-if="regMsgTextErr != ''">
                            <div class="alert-message md-form">
                                <div class="alert alert-danger">{{ regMsgTextErr }}</div>
                            </div>
                        </div>
                        <div v-if="regMsgTextSucc != ''">
                            <div class="alert-message md-form">
                                <div class="alert alert-success">{{ regMsgTextSucc }}</div>
                            </div>
                        </div>
                        <div class="step-bar">
                            <ul>
                                <li v-for="step in steps" :key="step" :class="{
                                    active: currStep >= step,
                                    completed: currStep > step
                                }">
                                    {{ step }}
                                </li>
                            </ul>
                        </div>
                        <div class="p-3 rounded">
                            <!-- <p class="text-muted fw-bold text-center">{{ $t('properties_list.add_property_title') }}
                            </p> -->
                        </div>

                        <div class="card" v-if="currStep == 1">
                            <div class="card-heading">
                                <h5>{{ $t('steps.step_1') }}</h5>
                            </div>
                            <div class="card-body md-form sort-sec">
                                <div class="form-group m-0">
                                    <div class="radio-buttons-wrapper custom-radio-group">
                                        <div v-for="(text, value) in translatedPropertyTypeOptions" :key="value"
                                            class="form-check custom-radio">
                                            <input type="radio" :id="'propertyType_' + value" :value="value"
                                                v-model="propertyData.propertyType" class="custom-control-input"
                                                name="propertyType">
                                            <label style="margin-left: 0px;" :for="'propertyType_' + value"
                                                class="custom-control-label">{{ text
                                                }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="currStep == 2">
                            <div class="card-heading">
                                <h5>{{ $t('steps.step_2') }}</h5>
                            </div>
                            <div class="card-body md-form sort-sec">
                                <div class="form-group m-0">
                                    <div class="radio-buttons-wrapper custom-radio-group">
                                        <div v-for="(text, value) in translatedAccomodationTypeOptions" :key="value"
                                            class="form-check custom-radio">
                                            <input type="radio" :id="'accomodationType_' + value" :value="value"
                                                v-model="propertyData.accomodationType" class="custom-control-input"
                                                name="accomodationType">
                                            <label style="margin-left: 0px;" :for="'accomodationType_' + value"
                                                class="custom-control-label">{{ text }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="card" v-if="currStep == 3">
                            <div class="card-heading">
                                <h5>What is the type of your Place?</h5>
                            </div>
                            <div class="card-body md-form sort-sec">
                                <div class="form-group m-0">
                                    <div class="radio-buttons-wrapper custom-radio-group">
                                        <div v-for="(text, value) in placeTypeOption" :key="value"
                                            class="form-check custom-radio">
                                            <input type="radio" :id="'placeType' + value" :value="value"
                                                v-model="propertyData.placeType" class="custom-control-input"
                                                name="placeType">
                                            <label style="margin-left: 0px;" :for="'placeType' + value"
                                                class="custom-control-label">{{ text
                                                }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="card" v-if="currStep == 3">
                            <div class="card-heading">
                                <h5>{{ $t('steps.step_3') }}</h5>
                            </div>
                            <div class="card-body md-form sort-sec">
                                <div class="form-group m-0">
                                    <div class="radio-buttons-wrapper custom-radio-group">
                                        <div v-for="(label, key) in translatedTargetaudienceOption" :key="key"
                                            class="form-check custom-radio">
                                            <input type="checkbox" :id="'targetaudience' + key" :value="key"
                                                :checked="propertyData.targetaudience.includes(key)"
                                                @change="toggleAudience(key, $event)" class="custom-control-input" />
                                            <label style="margin-left: 0px;" :for="'targetaudience' + key"
                                                class="custom-control-label">
                                                {{ label }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card second-step" v-if="currStep == 4">
                            <div class="card-heading">
                                <h5>{{ $t('steps.step_4') }}</h5>
                            </div>
                            <div class="card-body md-form sort-sec">
                                <div class="form-group m-0">
                                    <div class="radio-buttons-wrapper custom-radio-group">
                                        <label class="form-label" for="wifiAvailable">{{ $t('property_detail.wifi')
                                        }}</label>
                                        <div v-for="(optionText, optionValue) in translatedyesnoOptions"
                                            :key="optionValue" class="form-check custom-radio">
                                            <input type="radio" :id="'wifiAvailable_' + optionValue"
                                                :value="optionValue" v-model="propertyData.wifiAvailable"
                                                class="custom-control-input" name="wifiGroup">
                                            <label :for="'wifiAvailable_' + optionValue" class="custom-control-label">{{
                                                optionText
                                            }}</label>
                                        </div>
                                    </div>
                                    <div class="radio-buttons-wrapper custom-radio-group">
                                        <label class="form-label">{{ $t('property_detail.kitchen') }}</label>
                                        <div v-for="(optionText, optionValue) in translatedyesnoOptions"
                                            :key="optionValue" class="form-check custom-radio">
                                            <input type="radio" :id="'kitchen_' + optionValue" :value="optionValue"
                                                v-model="propertyData.kitchen" class="custom-control-input"
                                                name="kitchenGroup">
                                            <label :for="'kitchen_' + optionValue" class="custom-control-label">{{
                                                optionText
                                            }}</label>
                                        </div>
                                    </div>
                                    <div class="radio-buttons-wrapper custom-radio-group">
                                        <label class="form-label">{{ $t('property_detail.tv') }}</label>
                                        <div v-for="(optionText, optionValue) in translatedyesnoOptions"
                                            :key="optionValue" class="form-check custom-radio">
                                            <input type="radio" :id="'tv_' + optionValue" :value="optionValue"
                                                v-model="propertyData.tv" class="custom-control-input" name="tvGroup">
                                            <label :for="'tv_' + optionValue" class="custom-control-label">{{ optionText
                                            }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="currStep == 5">
                            <div class="card-heading">
                                <h5>{{ $t('steps.step_5') }}</h5>
                            </div>
                            <div class="card-body md-form accommodation-form">
                                <div class="form-group">
                                    <label for="max_guests">{{ $t('property_detail.Number_of_guests') }} <span
                                            class="text-red">*</span></label>
                                    <input type="number" id="max_guests" name="max_guests"
                                        :placeholder="$t('property_detail.Number_of_guests')" class="form-control"
                                        autocomplete="off" v-model="$v.propertyData.max_guests.$model" :maxlength="16"
                                        :state="$v.propertyData.max_guests.$dirty ? !$v.propertyData.max_guests.$error : null"
                                        aria-describedby="input-1-live-feedback">
                                </div>
                                <!-- <div class="form-group">
                                    <label for="min_guests">Minimum Guests Stay Duration<span
                                            class="text-red">*</span></label>
                                    <input type="number" id="min_guests" name="min_guests"
                                        :placeholder="$t('Minimum Guests Stay Duration')" class="form-control"
                                        autocomplete="off" v-model="$v.propertyData.min_guests.$model" :maxlength="16"
                                        :state="$v.propertyData.min_guests.$dirty ? !$v.propertyData.min_guests.$error : null"
                                        aria-describedby="input-1-live-feedback">
                                </div> -->
                                <div class="form-group">
                                    <label for="num_bedrooms">{{ $t('property_detail.Number_of_bedrooms') }} <span
                                            class="text-red">*</span></label>
                                    <input type="number" id="num_bedrooms" name="num_bedrooms"
                                        :placeholder="$t('property_detail.Number_of_bedrooms')" class="form-control"
                                        autocomplete="off" v-model="$v.propertyData.num_bedrooms.$model"
                                        :state="$v.propertyData.num_bedrooms.$dirty ? !$v.propertyData.num_bedrooms.$error : null"
                                        aria-describedby="input-1-live-feedback">
                                </div>
                                <div class="form-group quality-fileds">
                                    <div class="guest-content">
                                        <label for="king-bed">
                                            {{ $t('property_detail.king_beds') }}
                                        </label>
                                        <div class="guest-col">
                                            <template>
                                                <div class="quantity">
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-btn variant="info" @click="kingBedDecrement()">-</b-btn>
                                                        </b-input-group-prepend>

                                                        <b-form-input type="number" min="0.00"
                                                            v-model="propertyData.king_size_bed"
                                                            :value="propertyData.king_size_bed"></b-form-input>

                                                        <b-input-group-append>
                                                            <b-btn variant="info" @click="kingBedIncrement()">+</b-btn>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="guest-content">
                                        <label for="king-bed">
                                            {{ $t('property_detail.queen_beds') }}
                                        </label>
                                        <div class="guest-col">
                                            <template>
                                                <div class="quantity">
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-btn variant="info" @click="queenBedDecrement()">-</b-btn>
                                                        </b-input-group-prepend>

                                                        <b-form-input type="number" min="0.00"
                                                            v-model="propertyData.queen_size_bed"
                                                            :value="propertyData.queen_size_bed"></b-form-input>

                                                        <b-input-group-append>
                                                            <b-btn variant="info" @click="queenBedIncrement()">+</b-btn>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="guest-content">
                                        <label for="king-bed">
                                            {{ $t('property_detail.sofa_beds') }}
                                        </label>
                                        <div class="guest-col">
                                            <template>
                                                <div class="quantity">
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-btn variant="info" @click="sofaBedDecrement()">-</b-btn>
                                                        </b-input-group-prepend>

                                                        <b-form-input type="number" min="0.00"
                                                            v-model="propertyData.sofa_bed"
                                                            :value="propertyData.sofa_bed"></b-form-input>

                                                        <b-input-group-append>
                                                            <b-btn variant="info" @click="sofaBedIncrement()">+</b-btn>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="num_bathrooms">{{ $t('property_detail.Number_of_bathrooms') }} <span
                                            class="text-red">*</span></label>
                                    <input type="number" id="num_bathrooms" name="num_bathrooms"
                                        :placeholder="$t('property_detail.Number_of_bathrooms')" class="form-control"
                                        autocomplete="off" v-model="$v.propertyData.num_bathrooms.$model"
                                        :state="$v.propertyData.num_bathrooms.$dirty ? !$v.propertyData.num_bathrooms.$error : null"
                                        aria-describedby="input-1-live-feedback">
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="currStep == 6">
                            <div class="card-heading">
                                <h5>{{ $t('steps.step_6') }}</h5>
                            </div>
                            <div class="card-body md-form amenities-form">
                                <div class="form-group mb-1">
                                    <div class="checkbox-group">
                                        <label class="custom-label">{{ $t('property_detail.Bedroom_Amenities')
                                        }}</label>

                                        <div class="form-check">
                                            <label for="King_Bed" class="form-check-label text-muted">
                                                <input type="checkbox" id="King_Bed" name="King_Bed" value="King_Bed"
                                                    v-model="propertyData.bedroom_Amenities" class="form-check-input">
                                                {{
                                                    $t('property_detail.King_Bed')
                                                }}
                                                <div class="input-helper" style="cursor: pointer;"></div>
                                            </label>
                                        </div>

                                        <div class="form-check">
                                            <label for="Double_Sofa_Bed" class="form-check-label text-muted">
                                                <input type="checkbox" id="Double_Sofa_Bed" name="Double_Sofa_Bed"
                                                    value="Double_Sofa_Bed" v-model="propertyData.bedroom_Amenities"
                                                    class="form-check-input">
                                                {{
                                                    $t('property_detail.Double_Sofa_Bed') }}
                                                <div class="input-helper" style="cursor: pointer;"></div>
                                            </label>
                                        </div>

                                        <div class="form-check">
                                            <label for="Double_Futon" class="form-check-label text-muted">
                                                <input type="checkbox" id="Double_Futon" name="Double_Futon"
                                                    value="Double_Futon" v-model="propertyData.bedroom_Amenities"
                                                    class="form-check-input">
                                                {{
                                                    $t('property_detail.Double_Futon')
                                                }}
                                                <div class="input-helper" style="cursor: pointer;"></div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group m-0">
                                    <div class="checkbox-group">
                                        <label class="custom-label">{{
                                            $t('property_detail.bathroom_amenities') }}:</label>

                                        <div class="form-check">
                                            <label for="Soap" class="form-check-label text-muted">
                                                <input type="checkbox" id="Soap" name="Soap" value="Soap"
                                                    v-model="propertyData.bathroom_Amenities" class="form-check-input">
                                                {{ $t('property_detail.Soap')
                                                }}
                                                <div class="input-helper" style="cursor: pointer;"></div>
                                            </label>
                                        </div>

                                        <div class="form-check">
                                            <label for="Towels_provided" class="form-check-label text-muted">
                                                <input type="checkbox" id="Towels_provided" name="Towels_provided"
                                                    value="Towels_provided" v-model="propertyData.bathroom_Amenities"
                                                    class="form-check-input">
                                                {{
                                                    $t('property_detail.Towels_provided') }}
                                                <div class="input-helper" style="cursor: pointer;"></div>
                                            </label>
                                        </div>

                                        <div class="form-check">
                                            <label for="Toilet" class="form-check-label text-muted">
                                                <input type="checkbox" id="Toilet" name="Toilet" value="Toilet"
                                                    v-model="propertyData.bathroom_Amenities" class="form-check-input">
                                                {{ $t('property_detail.Toilet')
                                                }}
                                                <div class="input-helper" style="cursor: pointer;"></div>
                                            </label>
                                        </div>

                                        <div class="form-check">
                                            <label for="Shower_only" class="form-check-label text-muted">
                                                <input type="checkbox" id="Shower_only" name="Shower_only"
                                                    value="Shower_only" v-model="propertyData.bathroom_Amenities"
                                                    class="form-check-input">
                                                {{
                                                    $t('property_detail.Shower_only')
                                                }}
                                                <div class="input-helper" style="cursor: pointer;"></div>
                                            </label>
                                        </div>

                                        <div class="form-check">
                                            <label for="Shampoo" class="form-check-label text-muted">
                                                <input type="checkbox" id="Shampoo" name="Shampoo" value="Shampoo"
                                                    v-model="propertyData.bathroom_Amenities" class="form-check-input">
                                                {{
                                                    $t('property_detail.Shampoo')
                                                }}
                                                <div class="input-helper" style="cursor: pointer;"></div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="currStep == 7">
                            <div class="card-heading">
                                <h5>{{ $t('steps.step_7') }}</h5>
                            </div>
                            <div class="card-body md-form step-five addProperty">
                                <div class="form-group" @dragover.prevent @drop.prevent="handleDrop">
                                    <div class="upload-img">
                                        <div class="image">
                                            <svg width="60" height="60" viewBox="0 0 60 60" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                    d="M35.5859 18.0137C35.5859 8.34367 27.7459 0.513672 18.0859 0.513672C8.42594 0.513672 0.585938 8.34367 0.585938 18.0137C0.585938 27.6837 8.41594 35.5137 18.0859 35.5137C27.7559 35.5137 35.5859 27.6837 35.5859 18.0137ZM18.0359 29.1437C16.7659 29.1437 15.7259 28.1137 15.7359 26.8337V14.7537L11.8459 18.6537C10.9459 19.5537 9.48594 19.5537 8.58594 18.6537C7.68594 17.7537 7.68594 16.2937 8.58594 15.3837L16.4059 7.54367C17.3059 6.64367 18.7659 6.64367 19.6659 7.54367L27.4859 15.3837C28.3859 16.2837 28.3859 17.7437 27.4859 18.6537C26.5859 19.5637 25.1259 19.5537 24.2259 18.6537L20.3359 14.7537V26.8337C20.3359 28.1037 19.3059 29.1437 18.0359 29.1437ZM48.5259 33.7437C48.5259 31.3737 46.6059 29.4537 44.2359 29.4537C41.8659 29.4937 39.9759 31.4437 40.0059 33.8137C40.0459 36.1337 41.9159 38.0037 44.2359 38.0437C46.6059 38.0437 48.5259 36.1137 48.5259 33.7537V33.7437ZM52.3159 17.9037H39.7059C39.7059 19.9437 39.4259 21.9137 38.8959 23.7837H52.3159C53.2959 23.7837 54.0759 24.5737 54.0759 25.5437V48.5337L51.9159 46.3337C51.3559 45.7737 50.6059 45.4537 49.8159 45.4537C49.0259 45.4537 48.2659 45.7837 47.7259 46.3437L43.7359 50.4637L33.5859 40.2637C32.4459 39.1137 30.5859 39.1037 29.4359 40.2537L23.8859 45.7637V38.7437C21.9659 39.2737 19.9859 39.5437 17.9959 39.5337V52.2537C17.9959 56.4637 21.4259 59.9037 25.6359 59.9037H52.3159C56.5259 59.9037 59.9559 56.4637 59.9559 52.2537V25.5637C59.9559 21.3537 56.5359 17.9137 52.3159 17.9137V17.9037Z"
                                                    fill="#D9D9D9" />
                                            </svg>
                                        </div>
                                        <label for="images">{{ $t('property_detail.choose_file') }}</label>
                                        <input type="file" id="images" name="images[]" @change="previewImages" multiple
                                            accept="image/*" :disabled="isImageValidating">
                                        <p>{{ $t('property_detail.drag_and_drop_image') }}</p>
                                        <div v-if="isImageValidating" class="validation-loader">
                                            <img src="https://staging.cheapcomforts.com/public/images/loader.gif"
                                                :alt="$t('property_detail.validating_images')" style="height: 20px;">
                                            <p>{{ $t('property_detail.validating_images') }}</p>
                                        </div>
                                    </div>

                                    <div v-if="propertyData.imagePreviews.length > 0" class="images-listing">
                                        <div v-for="(imagePreview, index) in propertyData.imagePreviews" :key="index"
                                            class="images-card">
                                            <img v-if="imagePreview.path" :src="imagePreview.path" alt="Preview">
                                            <img v-else :src="imagePreview" alt="Preview">
                                            <button type="button" class="btn btn-primary" @click="removeImage(index)">
                                                <svg width="26" height="26" viewBox="0 0 26 26" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M15.7868 12.9865L24.7344 4.14649C25.5503 3.34411 25.5572 2.02987 24.7551 1.21366C23.953 0.397447 22.6392 0.39053 21.8233 1.19291L12.8758 10.0329L4.03193 1.08223C3.22983 0.266023 1.91605 0.259106 1.10012 1.06148C0.284189 1.87078 0.277274 3.18502 1.07937 4.00123L9.91629 12.9519L0.968739 21.7919C0.152811 22.5943 0.145896 23.9085 0.947995 24.7247C1.35596 25.1328 1.88839 25.3403 2.42082 25.3403C2.95324 25.3403 3.47184 25.1397 3.87981 24.7386L12.8274 15.8986L21.6643 24.8492C22.0722 25.2573 22.6047 25.4648 23.1371 25.4648C23.6695 25.4648 24.1881 25.2642 24.5961 24.8631C25.412 24.0607 25.4189 22.7464 24.6168 21.9302L15.7799 12.9796L15.7868 12.9865Z"
                                                        fill="white" />
                                                </svg>
                                                <!-- {{ $t('property_detail.Remove') }} -->
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="currStep == 8">
                            <div class="card-heading">
                                <h5>{{ $t('steps.step_8') }}</h5>
                            </div>
                            <div class="card-body md-form">
                                <div class="form-group">
                                    <label for="description">{{ $t('property_detail.Description') }}</label>
                                    <textarea id="description" class="form-control" v-model="propertyData.description"
                                        :placeholder="$t('property_detail.Description')" rows="3"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="currStep == 9">
                            <div class="card-heading">
                                <h5>{{ $t('steps.step_9') }}</h5>

                            </div>
                            <div class="card-body md-form">
                                <!-- Stay Duration Selection -->
                                <div class="form-group">
                                    <label>{{ $t('property_detail.stay_duration') }}</label>
                                    <div class="row g-2 align-items-center">
                                        <!-- Minimum Stay -->
                                        <div class="col-md-3 col-sm-6 col-6">
                                            <input type="number" @change="handleStayChange" v-model.number="minStay"
                                                class="form-control" :min="1" required />
                                        </div>
                                        <div class="col-md-2 col-sm-6 col-6">
                                            <select v-model="minStayUnit" class="form-control"
                                                @change="handleStayChange">
                                                <!-- <option value="nights">Nights</option>
                                                <option value="weeks">Weeks</option> -->
                                                <option value="months">{{ $t('property_detail.months') }}</option>
                                            </select>
                                        </div>

                                        <!-- "to" separator -->
                                        <div class="col-md-1 text-center">
                                            <span class="fw-bold">{{ $t('property_detail.to') }}</span>
                                        </div>

                                        <!-- Maximum Stay -->
                                        <div class="col-md-3 col-sm-6 col-6">
                                            <input type="number" @change="handleStayChange" v-model.number="maxStay"
                                                class="form-control" :min="1" required />
                                        </div>
                                        <div class="col-md-2 col-sm-6 col-6">
                                            <select v-model="maxStayUnit" class="form-control"
                                                @change="handleStayChange">
                                                <!-- <option value="nights">Nights</option>
                                                <option value="weeks">Weeks</option> -->
                                                <option value="months">{{ $t('property_detail.months') }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div v-if="nightPriceToggle" class="card-body md-form">
                                <div class="form-group">
                                    <label for="price">{{ $t('property_detail.Price_per_night') }} <span
                                            class="text-red">*</span></label>
                                    <div>
                                        <input type="number" id="price" name="price" class="form-control"
                                            :placeholder="$t('property_detail.Price')" v-model="propertyData.price"
                                            :state="$v.propertyData.price.$dirty ? !$v.propertyData.price.$error : null"
                                            aria-describedby="input-1-live-feedback" required>
                                    </div>
                                    <div class="invalid-feedback" v-if="$v.propertyData.price.$error"
                                        id="input-1-live-feedback">
                                        {{ $t('common.required_field') }}
                                    </div>
                                    <span v-if="propertyData.priceAmount" class="text-danger">{{
                                        propertyData.priceAmount
                                    }}</span>
                                </div>
                                <div class="row m-0">
                                    <div class="col-lg-4">
                                        <label for="price">{{ $t('property_detail.add_discount_specific_days')
                                            }}</label>
                                        <div class="form-check form-switch m-0">
                                            <label class="switch m-0">
                                                <input class="form-check-input" type="checkbox" id="discountToggle"
                                                    v-model="discountToggle">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <label for="price">{{ $t('property_detail.add_discount_long_stays') }}</label>
                                        <div class="form-check form-switch m-0">
                                            <label class="switch m-0">
                                                <input class="form-check-input" type="checkbox" id="longstaysToggle"
                                                    v-model="longstaysToggle">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <label for="price">{{ $t('property_detail.add_flash_discount') }}</label>
                                        <div class="form-check form-switch m-0">
                                            <label class="switch">
                                                <input class="form-check-input" type="checkbox" id="flashdiscountToggle"
                                                    v-model="flashdiscountToggle">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <span>{{ $t('property_detail.flash_offer_note') }}</span>
                            </div>
                            <div v-if="nightPriceToggle"
                                class="row mx-0 for-custom-style property-calendar-adjustement">
                                <div class="col-lg-4">
                                    <div class="card-body pricing-form md-form mx-0" v-if="discountToggle">
                                        <div class="form-group m-0">
                                            <div>
                                                <div class="mb-4">
                                                    <label for="discountPercentage">{{
                                                        $t('property_detail.discount_percentage') }}</label>
                                                    <select id="discountPercentage" name="discountPercentage"
                                                        class="form-control" v-model="propertyData.discountpersentage">
                                                        <option value="" disabled selected>{{
                                                            $t('property_detail.select_discount_percentage')
                                                            }}
                                                        </option>
                                                        <option v-for="percent in discountOptions" :key="percent"
                                                            :value="percent">
                                                            {{ percent }}%
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-12 mb-4">
                                                    <label for="discount">{{ $t('property_detail.discount_start_date')
                                                        }}</label>
                                                    <div>
                                                        <!-- <input type="date" id="discountprice" name="discountprice"
                                                            class="form-control" placeholder="Discounted Price"
                                                            v-model="propertyData.discountsdate"> -->
                                                        <date-range-picker v-model="dateRangeStart" :min-date="today"
                                                            :format="format" :placeholder="placeholder"
                                                            :date-format="dateFormat" :ranges='false'
                                                            :locale-data="locale_data" :key="localeKey"
                                                            :single-date-picker="true" />
                                                    </div>

                                                </div>
                                                <div class="col-lg-12 mb-4">
                                                    <label for="discount">{{ $t('property_detail.discount_end_date')
                                                        }}</label>
                                                    <div>
                                                        <!-- <input type="date" id="discountprice" name="discountprice"
                                                            class="form-control" placeholder="Discounted Price"
                                                            v-model="propertyData.discountedate"> -->
                                                        <date-range-picker v-model="dateRangeEnd" :min-date="today"
                                                            :format="format" :placeholder="placeholder"
                                                            :date-format="dateFormat" :ranges='false'
                                                            :locale-data="locale_data" :key="localeKey"
                                                            :single-date-picker="true" />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 p-lg-0">
                                    <div class="card-body pricing-form md-form mt-0 pt-0 mx-0" v-if="longstaysToggle">
                                        <div class="form-group m-0">
                                            <div>
                                                <div class="row">
                                                    <div class="col-lg-12 mb-4">
                                                        <div>
                                                            <label for="discountPercentage">{{
                                                                $t('property_detail.one_week_stay') }}</label>
                                                            <select id="discountPercentage" name="discountPercentage"
                                                                class="form-control" v-model="propertyData.oneweekdisc">
                                                                <option value="0" selected>{{
                                                                    $t('property_detail.select_discount_percentage')
                                                                    }}
                                                                </option>
                                                                <option v-for="percent in discountOptions"
                                                                    :key="percent" :value="percent">
                                                                    {{ percent }}%
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-12 mb-4">
                                                        <div class=" ">
                                                            <label for="discountPercentage">{{
                                                                $t('property_detail.two_week_stay') }}</label>
                                                            <select id="discountPercentage" name="discountPercentage"
                                                                class="form-control" v-model="propertyData.twoweekdisc">
                                                                <option value="0" selected>{{
                                                                    $t('property_detail.select_discount_percentage')
                                                                    }}
                                                                </option>
                                                                <option v-for="percent in discountOptions"
                                                                    :key="percent" :value="percent">
                                                                    {{ percent }}%
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-lg-12 mb-4">
                                                        <div class="mt-0">
                                                            <label for="discountPercentage">{{
                                                                $t('property_detail.three_week_stay') }}</label>
                                                            <select id="discountPercentage" name="discountPercentage"
                                                                class="form-control"
                                                                v-model="propertyData.threeweekdisc">
                                                                <option value="0" selected>{{
                                                                    $t('property_detail.select_discount_percentage')
                                                                    }}
                                                                </option>
                                                                <option v-for="percent in discountOptions"
                                                                    :key="percent" :value="percent">
                                                                    {{ percent }}%
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="col-lg-12 mb-4">
                                                        <div class="mt-0">
                                                            <label for="discountPercentage">One-month stay</label>
                                                            <select id="discountPercentage" name="discountPercentage"
                                                                class="form-control" v-model="propertyData.onemonthdis">
                                                                <option value="" disabled selected>Select a discount
                                                                    percentage
                                                                </option>
                                                                <option v-for="percent in discountOptions"
                                                                    :key="percent" :value="percent">
                                                                    {{ percent }}%
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="card-body pricing-form md-form mt-0 pt-0 mx-0"
                                        v-if="flashdiscountToggle">
                                        <div class="form-group m-0">
                                            <div>
                                                <div class="mb-4">
                                                    <label for="flashdiscountPercentage">{{
                                                        $t('property_detail.flash_discount_percentage')
                                                        }}</label>
                                                    <select id="flashdiscountPercentage" name="flashdiscountPercentage"
                                                        class="form-control"
                                                        v-model="propertyData.flashdiscountPercentage">
                                                        <option value="" disabled selected>{{
                                                            $t('common.select_flash_discount_percentage') }}
                                                        </option>
                                                        <option v-for="percent in flashdiscountOptions" :key="percent"
                                                            :value="percent">
                                                            {{ percent }}%
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="row right-calendar">
                                                <div class="col-lg-12 mb-4">
                                                    <label for="discount">{{ $t('property_detail.discount_date')
                                                        }}</label>
                                                    <div>
                                                        <!-- <input type="date" id="discountprice" name="discountprice"
                                                            class="form-control" placeholder="Discounted Price"
                                                            v-model="propertyData.flashstartDate"> -->
                                                        <date-range-picker v-model="dateRangeFlash" :min-date="today"
                                                            :format="format" :placeholder="placeholder"
                                                            :date-format="dateFormat" :ranges='false'
                                                            :locale-data="locale_data" :key="localeKey"
                                                            :single-date-picker="true" />
                                                    </div>
                                                </div>
                                                <!-- <div class="col-lg-6 mb-4">
                                                    <label for="discount">Discount End Date</label>
                                                    <div>
                                                        <input type="date" id="discountprice" name="discountprice"
                                                            class="form-control" placeholder="Discounted Price"
                                                            v-model="propertyData.flashendDate">
                                                    </div>
                                                </div> -->
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="monthlyPriceToggle" class="card-body">
                                <div class="col-md-12 p-0">
                                    <div>
                                        <div class="form-group">
                                            <label for="monthlyPrice">{{ $t('placeholder_texts.price_per_month') }}<span
                                                    class="text-red">*</span></label>
                                            <input type="number" id="monthlyPrice" name="monthlyPrice"
                                                class="form-control" v-model="propertyData.monthlyPrice"
                                                :placeholder="$t('placeholder_texts.price_per_month')">
                                        </div>
                                        <div class="row m-0">
                                            <div class="col-lg-4 form-check">
                                                <label for="price" class="form-check-label text-muted">
                                                    <input class="form-check-input " type="checkbox"
                                                        id="longstaysToggle" v-model="shortMonthstaysToggle">
                                                    {{ $t('property_detail.discount_on_medium_term_stays') }}
                                                    <div class="input-helper" style="cursor: pointer;"></div>
                                                </label>
                                            </div>
                                            <div class="col-lg-4  form-check">
                                                <label for="price" class="form-check-label text-muted">
                                                    <input class="form-check-input" type="checkbox" id="longstaysToggle"
                                                        v-model="longMonthstaysToggle">
                                                    {{ $t('property_detail.discount_on_long_term_stays') }}
                                                    <div class="input-helper" style="cursor: pointer;"></div>
                                                </label>
                                            </div>
                                            <div class="col-lg-4  form-check">
                                                <label for="price" class="form-check-label text-muted">
                                                    <input class="form-check-input" type="checkbox"
                                                        id="flashdiscountToggle" v-model="monthlyflashdiscountToggle">
                                                    {{ $t('property_detail.add_flash_discount') }}
                                                    <div class="input-helper" style="cursor: pointer;"></div>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="monthlyPriceToggle"
                                class="row mx-0 for-custom-style property-calendar-adjustement">
                                <div class="col-lg-4">
                                    <div class="card-body pricing-form md-form mt-0 pt-0 mx-0"
                                        v-if="shortMonthstaysToggle">
                                        <div class="form-group m-0">
                                            <div>
                                                <div class="row">
                                                    <div class="col-lg-12 mb-4">
                                                        <div>
                                                            <label for="discountPercentage">{{
                                                                $t('property_detail.one_month_stay') }}</label>
                                                            <select id="discountPercentage" name="discountPercentage"
                                                                class="form-control" v-model="propertyData.onemonthdis">
                                                                <option value="0" selected>{{
                                                                    $t('property_detail.select_discount_percentage')
                                                                    }}
                                                                </option>
                                                                <option v-for="percent in discountOptions"
                                                                    :key="percent" :value="percent">
                                                                    {{ percent }}%
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-12 mb-4">
                                                        <div class=" ">
                                                            <label for="discountPercentage">{{
                                                                $t('property_detail.two_month_stay') }}</label>
                                                            <select id="discountPercentage" name="discountPercentage"
                                                                class="form-control"
                                                                v-model="propertyData.twomonthsdis">
                                                                <option value="0" selected>{{
                                                                    $t('property_detail.select_discount_percentage')
                                                                    }}
                                                                </option>
                                                                <option v-for="percent in discountOptions"
                                                                    :key="percent" :value="percent">
                                                                    {{ percent }}%
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-lg-12 mb-4">
                                                        <div class="mt-0">
                                                            <label for="discountPercentage">{{
                                                                $t('property_detail.three_month_stay') }}</label>
                                                            <select id="discountPercentage" name="discountPercentage"
                                                                class="form-control"
                                                                v-model="propertyData.threemonthsdis">
                                                                <option value="0" selected>{{
                                                                    $t('property_detail.select_discount_percentage')
                                                                    }}
                                                                </option>
                                                                <option v-for="percent in discountOptions"
                                                                    :key="percent" :value="percent">
                                                                    {{ percent }}%
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-12 mb-4">
                                                        <div class="mt-0">
                                                            <label for="discountPercentage">{{
                                                                $t('property_detail.four_month_stay') }}</label>
                                                            <select id="discountPercentage" name="discountPercentage"
                                                                class="form-control"
                                                                v-model="propertyData.fourmonthsdis">
                                                                <option value="0" selected>{{
                                                                    $t('property_detail.select_discount_percentage')
                                                                    }}
                                                                </option>
                                                                <option v-for="percent in discountOptions"
                                                                    :key="percent" :value="percent">
                                                                    {{ percent }}%
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="card-body pricing-form md-form mt-0 pt-0 mx-0"
                                        v-if="longMonthstaysToggle">
                                        <div class="form-group m-0">
                                            <div>
                                                <div class="row">
                                                    <div class="col-lg-12 mb-4">
                                                        <div>
                                                            <label for="discountPercentage">{{
                                                                $t('property_detail.five_month_stay') }}</label>
                                                            <select id="discountPercentage" name="discountPercentage"
                                                                class="form-control"
                                                                v-model="propertyData.fivemonthsdis">
                                                                <option value="0" selected>{{
                                                                    $t('property_detail.select_discount_percentage')
                                                                    }}
                                                                </option>
                                                                <option v-for="percent in discountOptions"
                                                                    :key="percent" :value="percent">
                                                                    {{ percent }}%
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-12 mb-4">
                                                        <div class=" ">
                                                            <label for="discountPercentage">{{
                                                                $t('property_detail.six_month_stay') }}</label>
                                                            <select id="discountPercentage" name="discountPercentage"
                                                                class="form-control"
                                                                v-model="propertyData.sixmonthsdis">
                                                                <option value="0" selected>{{
                                                                    $t('property_detail.select_discount_percentage')
                                                                    }}
                                                                </option>
                                                                <option v-for="percent in discountOptions"
                                                                    :key="percent" :value="percent">
                                                                    {{ percent }}%
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-lg-12 mb-4">
                                                        <div class="mt-0">
                                                            <label for="discountPercentage">{{
                                                                $t('property_detail.seven_month_stay') }}</label>
                                                            <select id="discountPercentage" name="discountPercentage"
                                                                class="form-control"
                                                                v-model="propertyData.sevenmonthsdis">
                                                                <option value="0" selected>{{
                                                                    $t('property_detail.select_discount_percentage')
                                                                    }}
                                                                </option>
                                                                <option v-for="percent in discountOptions"
                                                                    :key="percent" :value="percent">
                                                                    {{ percent }}%
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-12 mb-4">
                                                        <div class="mt-0">
                                                            <label for="discountPercentage">{{
                                                                $t('property_detail.eight_month_stay') }}</label>
                                                            <select id="discountPercentage" name="discountPercentage"
                                                                class="form-control"
                                                                v-model="propertyData.eightmonthsdis">
                                                                <option value="0" selected>{{
                                                                    $t('property_detail.select_discount_percentage')
                                                                    }}
                                                                </option>
                                                                <option v-for="percent in discountOptions"
                                                                    :key="percent" :value="percent">
                                                                    {{ percent }}%
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="card-body pricing-form md-form mt-0 pt-0 mx-0"
                                        v-if="monthlyflashdiscountToggle">
                                        <div class="form-group m-0">
                                            <div>
                                                <div class="mb-4">
                                                    <label for="monthlyflashdiscountPercentage">{{
                                                        $t('property_detail.flash_discount_percentage') }}</label>
                                                    <select id="monthlyflashdiscountPercentage"
                                                        name="monthlyflashdiscountPercentage" class="form-control"
                                                        v-model="propertyData.monthlyflashdiscountPercentage">
                                                        <option value="" disabled selected>{{
                                                            $t('property_detail.select_discount_percentage')
                                                            }}
                                                        </option>
                                                        <option v-for="percent in flashdiscountOptions" :key="percent"
                                                            :value="percent">
                                                            {{ percent }}%
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="row right-calendar">
                                                <div class="col-lg-12 mb-4">
                                                    <label for="discount">{{ $t('property_detail.discount_date')
                                                        }}</label>
                                                    <div>
                                                        <date-range-picker v-model="dateRangeMonthly" :min-date="today"
                                                            :format="format" :placeholder="placeholder"
                                                            :date-format="dateFormat" :ranges='false'
                                                            :locale-data="locale_data" :key="localeKey"
                                                            :single-date-picker="true" />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="card" v-if="currStep == 10">
                            <div class="card-heading">
                                <h5>{{ $t('steps.step_10') }}</h5>
                            </div>
                            <div class="card-body md-form house-form">
                                <div class="form-group">
                                    <label for="min_age" class="form-label">{{ $t('property_detail.min_age_to_rent')
                                    }} <span class="text-red">*</span></label>
                                    <input type="number" id="min_age" name="min_age"
                                        :placeholder="$t('property_detail.min_age_to_rent')"
                                        v-model="$v.propertyData.min_age.$model"
                                        :class="{ 'is-invalid': $v.propertyData.min_age.$dirty && $v.propertyData.min_age.$error }"
                                        aria-describedby="minage" class="form-control">
                                    <div v-if="$v.propertyData.min_age.$error" id="minage" class="invalid-feedback">
                                        {{ $t('common.required_field') }}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="children" class="form-label">{{ $t('property_detail.children')
                                    }} <span class="text-red">*</span></label>
                                    <!-- <select id="children" name="children" v-model="propertyData.children"
                                        :class="{ 'is-invalid': $v.propertyData.children.$dirty && $v.propertyData.children.$error }"
                                        class="form-control">
                                        <option value="" disabled>{{ $t('common.select_option') }}</option>
                                        <option v-for="option in translatedChildrens" :key="option" :value="option">
                                            {{ option }}
                                        </option>
                                    </select> -->
                                    <select id="children" name="children" v-model="propertyData.children"
                                        :class="{ 'is-invalid': $v.propertyData.children.$dirty && $v.propertyData.children.$error }"
                                        class="form-control">
                                        <option value="" disabled>{{ $t('common.select_option') }}</option>
                                        <option v-for="option in translatedChildrens" :key="option.key"
                                            :value="option.key">
                                            {{ option.label }}
                                        </option>
                                    </select>

                                    <div v-if="$v.propertyData.children.$error" id="input-1-live-feedback"
                                        class="invalid-feedback">
                                        {{ $t('common.required_field') }}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="Events" class="form-label">{{ $t('property_detail.events') }} <span
                                            class="text-red">*</span></label>
                                    <!-- <select id="Events" name="Events" v-model="propertyData.Events"
                                        :class="{ 'is-invalid': $v.propertyData.Events.$dirty && $v.propertyData.Events.$error }"
                                        class="form-control">
                                        <option value="" disabled>{{ $t('common.select_option') }}</option>
                                        <option v-for="option in translatedEvents" :key="option" :value="option">
                                            {{ option }}
                                        </option>
                                    </select> -->
                                    <select id="Events" name="Events" v-model="propertyData.Events"
                                        :class="{ 'is-invalid': $v.propertyData.Events.$dirty && $v.propertyData.Events.$error }"
                                        class="form-control">
                                        <option value="" disabled>{{ $t('common.select_option') }}</option>
                                        <option v-for="option in translatedEvents" :key="option.key"
                                            :value="option.key">
                                            {{ option.label }}
                                        </option>
                                    </select>

                                    <div v-if="$v.propertyData.Events.$error" id="Events-feedback"
                                        class="invalid-feedback">
                                        {{ $t('common.required_field') }}
                                    </div>
                                </div>
                                <div class="form-group pets-allowed">
                                    <label for="Pets" class="form-label">{{ $t('property_detail.pets') }} <span
                                            class="text-red">*</span></label>
                                    <select id="Pets" name="Pets" v-model="propertyData.Pets"
                                        :class="{ 'is-invalid': $v.propertyData.Pets.$dirty && $v.propertyData.Pets.$error }"
                                        class="form-control">
                                        <option value="" disabled>{{ $t('common.select_option') }}</option>
                                        <option v-for="option in translatedPets" :key="option.key" :value="option.key">
                                            {{ option.label }}
                                        </option>
                                    </select>
                                    <div v-if="$v.propertyData.Pets.$error" id="Pets-feedback" class="invalid-feedback">
                                        {{ $t('common.required_field') }}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="Smoking" class="form-label">{{ $t('property_detail.smoking') }} <span
                                            class="text-red">*</span></label>
                                    <select id="Smoking" name="Smoking" v-model="propertyData.Smoking"
                                        :class="{ 'is-invalid': $v.propertyData.Smoking.$dirty && $v.propertyData.Smoking.$error }"
                                        class="form-control">
                                        <option value="" disabled>{{ $t('common.select_option') }}</option>
                                        <option v-for="option in translatedSmoking" :key="option.key"
                                            :value="option.key">
                                            {{ option.label }}
                                        </option>
                                    </select>
                                    <div v-if="$v.propertyData.Smoking.$error" id="Smoking-feedback"
                                        class="invalid-feedback">
                                        {{ $t('common.required_field') }}
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="card" v-if="currStep == 11">
                            <div class="card-heading">
                                <h5>{{ $t('steps.step_11') }}</h5>
                            </div>
                            <div class="card-body md-form house-form">
                                <div class="form-group">
                                    <label for="city">{{ $t('properties_list.city') }} <span
                                            class="text-red">*</span></label>
                                    <input type="text" id="city" name="city" class="form-control"
                                        :placeholder="$t('properties_list.city_placeholder')"
                                        v-model="propertyData.city"
                                        :class="{ 'is-invalid': $v.propertyData.city.$error }"
                                        aria-describedby="input-1-live-feedback">
                                </div>
                                <div class="form-group">
                                    <label for="state">{{ $t('properties_list.state') }}</label>
                                    <input type="text" id="state" name="state" class="form-control"
                                        :placeholder="$t('properties_list.state_placeholder')"
                                        v-model="propertyData.state"
                                        :class="{ 'is-invalid': $v.propertyData.state.$error }"
                                        aria-describedby="input-1-live-feedback">
                                </div>
                                <!-- <div class="form-group">
                                    <label for="country">{{ $t('property_detail.Country') }}</label>
                                    <input type="text-area" id="country" name="country" class="form-control"
                                        :placeholder="$t('property_detail.Country')" v-model="propertyData.country"
                                        :class="{ 'is-invalid': $v.propertyData.country.$error }"
                                        aria-describedby="input-1-live-feedback">
                                </div> -->
                                <div class="form-group">
                                    <label for="country">{{ $t('property_detail.Country') }} <span
                                            class="text-red">*</span></label>
                                    <select id="country" name="country" v-model="propertyData.country"
                                        class="form-control" :class="{ 'is-invalid': $v.propertyData.country.$error }">
                                        <option value="" disabled>{{ $t('properties_list.country_placeholder') }}
                                        </option>
                                        <option v-for="country in countries" :key="country.id" :value="country.name">
                                            {{ country.name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="address">{{ $t('property_detail.address') }} <span
                                            class="text-red">*</span></label>
                                    <input type="text" id="address" name="address" class="form-control"
                                        @change="onInput" :placeholder="$t('properties_list.address_placeholder')"
                                        v-model="propertyData.address"
                                        :class="{ 'is-invalid': $v.propertyData.address.$error }"
                                        aria-describedby="input-1-live-feedback">

                                    <ul v-if="suggestions.length > 0" class="suggestions-list" style="z-index: 9999;">
                                        <li v-for="(suggestion, index) in suggestions" :key="index"
                                            @click="selectSuggestion(suggestion)">
                                            {{ suggestion.description }}
                                        </li>
                                    </ul>
                                </div>
                                <div class="form-group">
                                    <label for="postal_code">{{ $t('properties_list.Postal_Code') }}<span
                                            class="text-red">*</span></label>
                                    <input type="text" id="postal_code" name="postal_code" class="form-control"
                                        :placeholder="$t('properties_list.postal_code_placeholder')"
                                        v-model="propertyData.postal_code"
                                        :class="{ 'is-invalid': $v.propertyData.postal_code.$error }"
                                        aria-describedby="input-1-live-feedback">
                                </div>
                                <!-- <div class="form-group">
                                    <label for="address">{{ $t('property_detail.address') }}</label>
                                    <input type="text-area" id="address" name="address" class="form-control"
                                        @input="onInput" :placeholder="$t('property_detail.address')"
                                        v-model="propertyData.address"
                                        :class="{ 'is-invalid': $v.propertyData.address.$error }"
                                        aria-describedby="input-1-live-feedback">
                                    <ul v-if="suggestions.length > 0" class="suggestions-list" style="z-index: 9999;">
                                        <li v-for="(suggestion, index) in suggestions" :key="index"
                                            @click="selectSuggestion(suggestion)">
                                            {{ suggestion.description }}
                                        </li>
                                    </ul>
                                </div> -->


                            </div>
                        </div>
                        <!-- <div class="card" v-if="currStep == 13">
                            <div class="card-heading">
                                <h5>Account Details</h5>
                            </div>
                            <div class="card-body md-form">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="checkin_after" class="form-label">{{
                                                $t('property_detail.cardholder_name') }}</label>
                                            <input type="text" id="Cardholder's Name" name="Cardholder's Name"
                                                placeholder="Cardholder's Name" aria-describedby="checkinafter"
                                                class="form-control">
                                            <div v-if="$v.propertyData.checkin_after.$error" id="checkinafter"
                                                class="invalid-feedback">
                                                This is a required field
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="checkin_after" class="form-label">{{ $t('property_detail.card_number')
                                                }}</label>
                                            <input type="text" id="Card Number" name="Card Number" placeholder="Card Number"
                                                aria-describedby="checkinafter" class="form-control">
                                            <div v-if="$v.propertyData.checkin_after.$error" id="checkinafter"
                                                class="invalid-feedback">
                                                This is a required field
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="checkin_after" class="form-label">{{ $t('property_detail.cvv')
                                                }}</label>
                                            <input type="text" id="CVV" name="CVV" placeholder="CVV"
                                                aria-describedby="checkinafter" class="form-control">
                                            <div v-if="$v.propertyData.checkin_after.$error" id="checkinafter"
                                                class="invalid-feedback">
                                                This is a required field
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="checkin_after" class="form-label">{{
                                                $t('property_detail.expiry_date') }}</label>
                                            <input type="date" id="Exp Date" name="Exp Date" placeholder="Exp Date"
                                                aria-describedby="checkinafter" class="form-control">
                                            <div v-if="$v.propertyData.checkin_after.$error" id="checkinafter"
                                                class="invalid-feedback">
                                                This is a required field
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="card laststep p-5" v-if="currStep == 12">
                            <div class="alldone-heading">
                                <div class="icon">
                                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="40" cy="40" r="40" fill="#70D3FF" />
                                        <path
                                            d="M58.3409 26.5233C57.0409 25.6233 55.0409 25.9233 53.8409 27.1233L35.7409 45.2233L26.9409 36.4233C26.2409 35.7233 25.4409 35.4233 24.4409 35.4233C23.4409 35.4233 22.5409 35.8233 21.8409 36.6233C20.6409 38.0233 20.7409 40.2233 22.0409 41.5233L34.0409 53.5233C34.4409 53.9233 35.0409 54.2233 35.7409 54.2233C36.3409 54.2233 36.9409 54.0233 37.4409 53.5233L58.9409 31.9233C59.6409 31.2233 60.0409 30.1233 59.9409 29.1233C59.8409 28.1233 59.2409 27.1233 58.3409 26.5233Z"
                                            fill="white" />
                                    </svg>
                                </div>
                                <h5>{{ $t('steps.step_12') }}</h5>
                                <!-- <h5>{{ $t('property_detail.all_done') }}!</h5> -->
                                <p> <strong>
                                        {{ $t('property_detail.publish_confirmation') }}
                                        <a href="/host-terms-and-conditions" target="_blank">{{
                                            $t('property_detail.host_terms') }}</a>,
                                        <a href="/termsofservice" target="_blank">{{
                                            $t('property_detail.terms_of_service') }}</a>,
                                        {{ $t('property_detail.platform_intermediary') }}
                                    </strong>
                                </p>
                                <p>{{ $t('property_detail.property_listed') }}</p>

                                <p class="text-muted mt-2" style="font-size: 14px;">
                                    {{ $t('property_detail.transaction_fee_notice') }}
                                </p>
                                <div class="form-check">
                                    <label class="form-check-label text-muted publishFacebook" for="publishFacebook">
                                        <input type="checkbox" id="publishFacebook" name="publishFacebook"
                                            class="form-check-input" v-model="propertyData.social_publish_status">
                                        <div class="input-helper" style="cursor: pointer;"></div>
                                         {{ $t('property_detail.allow_property_on_social_media') }}
                                    </label>
                                </div>
                            </div>
                            <div class="md-form">
                                <button type="button" class="btn btn-primary list-property" @click="addProperty()"
                                    :disabled="isDisabled || isLoading" style="margin-left: 60%; ">
                                    <span v-if="!isLoading">{{ $t('property_detail.list_property') }}</span>
                                    <span v-else>
                                        <i class="fa fa-spinner fa-spin"></i> {{ $t('register.loading') }}
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div class="foot-btn" v-if="currStep < 13">
                            <div class="footer-buttons md-form">
                                <button id="bckBtn" name="bckBtn" class="btn btn-default pull-left" v-if="currStep > 1"
                                    @click="bckBtn" :disabled="regBusy">
                                    <span v-if="!regBusy">{{ $t('register.back') }}</span>
                                    <span v-else>
                                        <i class="fa fa-spinner fa-spin"></i> {{ $t('register.loading') }}
                                    </span>
                                </button>

                                <button id="regSub" name="regSub" class="btn btn-primary pull-right" @click="regSub"
                                    :disabled="regBusy" v-if="currStep < 12">
                                    <span v-if="!regBusy">{{ regBtnText }}</span>
                                    <span v-else>
                                        <i class="fa fa-spinner fa-spin"></i> {{ $t('register.loading') }}
                                    </span>
                                </button>
                            </div>
                        </div>
                        <!-- <div class="foot-btn" v-if="currStep == 14">
                            <div class="card-body md-form">
                                <button id="regSingIn" name="regSingIn" class="btn btn-primary pull-right"
                                    @click="regSingIn">{{
                                        $t('register.sign_in') }}</button>
                            </div>
                        </div> -->

                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import { Loader } from '@googlemaps/js-api-loader';
import moment from 'moment';
import Snotify, { SnotifyPosition } from 'vue-snotify'
import { validationMixin } from "vuelidate";
import { required, minLength, url, email, sameAs } from "vuelidate/lib/validators";
import DateRangePicker from 'vue2-daterange-picker';
import * as mobilenet from "@tensorflow-models/mobilenet";
import * as tf from "@tensorflow/tfjs";
const options = {
    toast: {
        position: SnotifyPosition.rightTop,
    }
}
Vue.use(Snotify, options)
export default {
    // name: addProperty,
    components: {
        DateRangePicker,
        // DatePicker,
    },
    mixins: [validationMixin],
    data() {
        return {
            currStep: 1,
            steps: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            regBtnText: this.$t('register.next'),
            regBusy: false,
            regEmail: '',
            regPhone: '',
            regFname: '',
            type: 'password',
            regPassword: '',
            discountOptions: [5, 10, 15, 20, 25, 30, 50],
            flashdiscountOptions: [20, 25, 30, 50],
            discountToggle: false,
            flashdiscountToggle: false,
            longstaysToggle: false,
            btnText: 'fa fa-eye',
            regCpassword: '',
            regMsgTextErr: '',
            regMsgTextSucc: '',
            region: localStorage.getItem('region'),
            maxPropertyPrice: 99,
            maxMonthlyPrice: 1600,
            bathroom_Amenities: {
                Soap: false,
                Towels_provided: false,
                Toilet: false,
                Shower_only: false,
                Shampoo: false,
            },
            bedroom_Amenities: {
                King_Bed: false,
                Double_Sofa_Bed: false,
                Double_Futon: false,
            },
            monthlyPriceToggle: true,
            nightPriceToggle: false,
            shortMonthstaysToggle: false,
            longMonthstaysToggle: false,
            monthlyflashdiscountToggle: false,
            minStay: 1,
            minStayUnit: "months",
            maxStay: 1,
            maxStayUnit: "months",
            propertyData: {
                lang: "en",
                city: "",
                state: "",
                country: "",
                address: "",
                postal_code: "",
                price: "",
                discountpersentage: "",
                flashdiscountPercentage: "",
                monthlyflashdiscountPercentage: "",
                oneweekdisc: "",
                twoweekdisc: "",
                threeweekdisc: "",
                onemonthdis: "",
                twomonthsdis: "",
                threemonthsdis: "",
                fourmonthsdis: "",
                fivemonthsdis: "",
                sixmonthsdis: "",
                sevenmonthsdis: "",
                eightmonthsdis: "",
                discountsdate: "",
                discountedate: "",
                flashstartDate: "",
                monthlyFlashstartDate: "",
                // flashendDate: "",
                priceAmount: "",
                max_guests: "",
                min_guests: "",
                num_bedrooms: "",
                // checkin_after: "",
                // checkout_before: "",
                num_bathrooms: "",
                min_age: "",
                propertyType: "",
                accomodationType: "",
                placeType: "",
                targetaudience: [],
                children: "",
                Events: "",
                Pets: "",
                Smoking: "",
                wifiAvailable: null,
                kitchen: null,
                tv: null,
                king_size_bed: 0,
                queen_size_bed: 0,
                sofa_bed: 0,
                description: "",
                imagePreviews: [],
                bathroom_Amenities: [],
                bedroom_Amenities: [],
                id: "",
                currency: 'USD',
                monthlyPrice: "",
                min_night_stay: 1,
                max_night_stay: 7,
                social_publish_status: false,
            },
            currencyOptions: [
                { value: 'USD', text: 'USD' },
                { value: 'EUR', text: 'Euro' },
                { value: 'GBP', text: 'Pound' },
                // Add more currencies as needed
            ],
            id: "",
            propertyTypeOptions: {
                'Entire_Place': 'Entire Place',
                'Private_Room': 'Private Room',
                'Shared_Room': 'Shared Room',
            },
            placeTypeOption: {
                'Beachfront': 'Beachfront',
                'Mountain': 'Mountain',
                'Camping': 'Camping',
                'Lakefront': 'Lakefront',
                'Snow': 'Snow',
                'Tropical': 'Tropical',
                'Central': 'Central',
                'Outskirts': 'Outskirts',
            },
            targetaudienceOption: {
                'Students': 'Students',
                'Temporary_Workers': 'Temporary Workers',
                'Digital_Nomad': 'Digital Nomad',
                'Expatriate': 'Expatriate',
                'Traveler': 'Traveler',
                'Freelancer': 'Freelancer',
                'Families': 'Families',
                'Couples': 'Couples',
                'Others': 'Others',
            },
            accomodationTypeOptions: {
                'Apartment': 'Apartment',
                'Duplex': 'Duplex',
                'Studio': 'Studio',
                'Chalet': 'Chalet',
                'Townhouse': 'Townhouse',
                'Duplex_apartment': 'Duplex apartment',
                'Detached_house': 'Detached house',
                'Loft': 'Loft',
                'Bungalow': 'Bungalow',
                'Micro_apartment': 'Micro-apartment',
                'Duplex_two_unit_home': 'Duplex (two-unit home)',
                'Triplex': 'Triplex',
                'Mobile_home': 'Mobile home',
                'Prefabricated_house': 'Prefabricated house',
                'Cabin': 'Cabin',
                'Semi_detached_house': 'Semi-detached house',
                'Row_house': 'Row house',
                'Penthouse': 'Penthouse',
                'Cottage': 'Cottage',
                'Villa': 'Villa',
                'Floating_home': 'Floating home',
                'Ranch': 'Ranch'
            },
            childrens: {
                'Not_Allowed': 'Not Allowed',
                'Allowed:_ages_0-13': 'Allowed: ages 0-13',
                'Allowed:_ages_0-17': 'Allowed: ages 0-17',
            },
            Events: {
                'Not_Allowed': 'Not Allowed',
                'Allowed:_Family_gatherings_and_Birthday_parties': 'Allowed: Family gatherings and Birthday parties',
                'Allowed:_Family_gatherings': 'Allowed: Family gatherings',
                'Allowed:_Birthday_parties': 'Allowed: Birthday parties',
            },
            Pets: {
                'Not_Allowed': 'Not Allowed',
                'Allowed:_cats_less_than_20_lbs_per_pet_(limit_1_pets_total)': 'Allowed: cats less than 20 lbs per pet (limit 1 pets total)',
                'Allowed:_cats_less_than_20_lbs_per_pet_(limit_2_pets_total)': 'Allowed: cats less than 20 lbs per pet (limit 2 pets total)',
                'Allowed:_cats_less_than_20_lbs_per_pet_(limit_3_pets_total)': 'Allowed: cats less than 20 lbs per pet (limit 3 pets total)',
            },
            Smoking: {
                'Not_Allowed': 'Not Allowed',
                'Allowed': 'Allowed',
                'Allowed:_in_designated_areas': 'Allowed: in designated areas',
            },
            yesNoOptions: {
                1: 'Yes',
                0: 'No'
            },
            countries: [],
            validaddress: true,
            placesService: null,
            suggestions: [],
            today: new Date(),
            localeKey: 0,
            placeholder: 'Select Date Range',
            format: 'YYYY-MM-DD',
            dateRange: {
                startDate: new Date(),
            },
            dateRangeFlash: {
                startDate: new Date(),

            },
            dateRangeStart: {
                startDate: new Date(),

            },
            dateRangeEnd: {
                startDate: new Date(),

            },
            dateRangeMonthly: {
                startDate: new Date(),

            },
            isImageValidating: false,
            isDisabled: false,
            isLoading: false,
        };
    },
    validations: {
        propertyData: {

            num_bathrooms: {
                required,
            },
            max_guests: {
                required,
            },
            min_guests: {
                required,
            },
            num_bedrooms: {
                required,
            },
            // checkin_after: {
            //     required,

            // },
            // checkout_before: {
            //     required,
            // },
            min_age: {
                required,
            },
            Events: {
                required,
            },
            Pets: {
                required,
            },
            Smoking: {
                required,
            },
            price: {
                required,
            },
            country: {
                required,
            },
            address: {
                required,
            },
            postal_code: {
                required,
            },
            state: {
                required,
            },
            city: {
                required,
            },
            propertyType: {
                required,
            },
            accomodationType: {
                required,
            },
            placeType: {
                required,
            },
            targetaudience: {
                required,
            },
            children: {
                required,
            },
            wifiAvailable: {
                required: (value) => value === 1 || value === 0,
            },
            kitchen: {
                required: (value) => value === 1 || value === 0,
            },
            tv: {
                required: (value) => value === 1 || value === 0,
            },

        }
    },
    methods: {
        nextStep() {
            if (this.currStep < 15) {
                this.currStep++;
                this.saveState();
            }
        },
        prevStep() {
            if (this.currStep > 1) {
                this.currStep--;
                this.saveState();
            }
        },
        getMaxPropertyPrice() {
            let currecny = localStorage.getItem('currency');
            API.getMaxPrice(currecny,
                data => {
                    let maxPrice = data.data.maxPrice
                    this.maxPropertyPrice = parseInt(maxPrice)
                }, err => (
                    console.log(err)
                ))
        },
        kingBedIncrement() {
            this.propertyData.king_size_bed++
        },
        kingBedDecrement() {
            if (this.propertyData.king_size_bed > 0) {
                this.propertyData.king_size_bed--
            }
        },
        queenBedIncrement() {
            this.propertyData.queen_size_bed++
        },
        queenBedDecrement() {
            if (this.propertyData.queen_size_bed > 0) {
                this.propertyData.queen_size_bed--
            }
        },
        sofaBedIncrement() {
            this.propertyData.sofa_bed++
        },
        sofaBedDecrement() {
            if (this.propertyData.sofa_bed > 0) {
                this.propertyData.sofa_bed--
            }
        },
        showPassword() {
            if (this.type === 'password') {
                this.type = 'text'
                this.btnText = 'fa fa-eye-slash'
            } else {
                this.type = 'password'
                this.btnText = 'fa fa-eye'
            }
        },
        bckBtn() {
            if (this.currStep > 1) {
                this.regMsgTextErr = '';
                this.regBtnText = this.$t('register.next');
                this.currStep = this.currStep - 1;
            }
        },
        enforcePhoneFormat() {
            let x = this.regPhone
                .replace(/\D/g, "")
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

            this.regPhone = !x[2]
                ? x[1]
                : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
        },
        convertToNights(value, unit) {
            if (unit === "weeks") return value * 7;
            if (unit === "months") return value * 30; // Approximate conversion
            return value;
        },
        handleStayChange() {
            this.propertyData.min_night_stay = this.convertToNights(this.minStay, this.minStayUnit);
            this.propertyData.max_night_stay = this.convertToNights(this.maxStay, this.maxStayUnit);
            // if(this.propertyData.max_night_stay >= 30) {
            //     this.monthlyPriceToggle = true;
            //     this.nightPriceToggle = false;
            // } else {
            //     this.nightPriceToggle = true;
            //     this.monthlyPriceToggle = false;

            // }
        },
        convertNightsToUnit(nightCount) {
            if (nightCount % 30 === 0) {
                return { value: nightCount / 30, unit: 'months' };
            } else if (nightCount % 7 === 0) {
                return { value: nightCount / 7, unit: 'weeks' };
            } else {
                return { value: nightCount, unit: 'nights' };
            }
        },
        regSub() {
            this.regMsgTextErr = '';
            if (this.currStep === 1) {
                this.$v.propertyData.propertyType.$touch();

                if (!this.$v.propertyData.propertyType.required) {
                    // this.regMsgTextErr = 'Please select the type of your accomodation';
                    this.regMsgTextErr = this.$t('validation.select_property_type');
                    return;
                }
                // if (!this.$v.propertyData.accomodationType.required) {
                //     this.regMsgTextErr = 'Please Select Type Of your Property';
                //     return;
                // }
                this.currStep = 2;
                this.regBtnText = this.$t('register.next');
            } else if (this.currStep === 2) {
                this.$v.propertyData.accomodationType.$touch();

                // if (!this.$v.propertyData.propertyType.required) {
                //     this.regMsgTextErr = 'Please Select Type Of your Accomodation';
                //     return;
                // }
                if (!this.$v.propertyData.accomodationType.required) {
                    // this.regMsgTextErr = 'Please select the type Of your property';
                    this.regMsgTextErr = this.$t('validation.select_property_type');
                    return;
                }
                this.currStep = 3;
                this.regBtnText = this.$t('register.next');
            }
            //  else if (this.currStep === 3) {
            //     this.$v.propertyData.placeType.$touch();

            //     // if (!this.$v.propertyData.propertyType.required) {
            //     //     this.regMsgTextErr = 'Please Select Type Of your Accomodation';
            //     //     return;
            //     // }
            //     if (!this.$v.propertyData.placeType.required) {
            //         this.regMsgTextErr = 'Please select the place type of your property';
            //         return;
            //     }
            //     this.currStep = 4;
            //     this.regBtnText = this.$t('register.next');
            // } 
            else if (this.currStep === 3) {
                this.$v.propertyData.targetaudience.$touch();
                if (!this.$v.propertyData.targetaudience.required) {
                    // this.regMsgTextErr = 'Please select your property target audience';
                    this.regMsgTextErr = this.$t('validation.select_target_audience');
                    return;
                }
                this.currStep = 4;
                this.regBtnText = this.$t('register.next');
            } else if (this.currStep === 4) {
                this.regBtnText = this.$t('register.next');
                if (this.propertyData.wifiAvailable === null) {
                    // this.regMsgTextErr = 'Please select a Wi-Fi option.';
                    this.regMsgTextErr = this.$t('validation.select_wifi_option');
                    return;
                }
                if (this.propertyData.kitchen === null) {
                    // this.regMsgTextErr = 'Please select a kitchen option.';
                    this.regMsgTextErr = this.$t('validation.select_kitchen_option');
                    return;
                }
                if (this.propertyData.tv === null) {
                    // this.regMsgTextErr = 'Please select a TV option.';
                    this.regMsgTextErr = this.$t('validation.select_tv_option');
                    return;
                }
                this.currStep = 5;
                this.regBtnText = this.$t('register.next');

            } else if (this.currStep == 5) {
                this.regBtnText = this.$t('register.next');
                if (!this.propertyData.max_guests) {
                    // this.regMsgTextErr = 'Please add the number of guests';
                    this.regMsgTextErr = this.$t('validation.add_max_guests');
                    return;
                }
                // if (!this.propertyData.min_guests) {
                //     this.regMsgTextErr = 'Please add a minimum stay duration for guests';
                //     return;
                // }
                if (!this.propertyData.num_bedrooms) {
                    // this.regMsgTextErr = 'Please add the number of bedrooms';
                    this.regMsgTextErr = this.$t('validation.add_bedrooms');
                    return;
                }
                if (!this.propertyData.num_bathrooms) {
                    // this.regMsgTextErr = 'Please add the number of bathrooms';
                    this.regMsgTextErr = this.$t('validation.add_bathrooms');
                    return;
                }
                this.currStep = 6;
                this.regBtnText = this.$t('register.next');
            } else if (this.currStep == 6) {
                this.currStep = 7;
                this.regBtnText = this.$t('register.next');
            } else if (this.currStep == 7) {
                if (!this.propertyData.imagePreviews.length) {
                    // this.regMsgTextErr = 'Please add the images of property';
                    this.regMsgTextErr = this.$t('validation.add_images');
                    return;
                }
                if (this.propertyData.imagePreviews.length < 4) {
                    // this.regMsgTextErr = 'Please add atleast 4 images of property';
                    this.regMsgTextErr = this.$t('validation.add_minimum_images');
                    return;
                }
                this.currStep = 8;
                this.regBtnText = this.$t('register.next');
            } else if (this.currStep == 8) {
                this.currStep = 9;
                this.regBtnText = this.$t('register.next');
            } else if (this.currStep == 9) {
                if (this.propertyData.max_night_stay > 365) {
                    this.regMsgTextErr = this.$t('validation.max_stay_limit');
                    return false;
                }
                if (this.propertyData.min_night_stay > this.propertyData.max_night_stay) {
                    this.regMsgTextErr = this.$t('validation.min_night_stay_greater_than_max');
                    return false;
                }
                if (this.nightPriceToggle && !this.propertyData.price) {
                    this.regMsgTextErr = this.$t('validation.add_price_per_night');
                    return;
                }
                if (this.monthlyPriceToggle && !this.propertyData.monthlyPrice) {
                    this.regMsgTextErr = this.$t('validation.add_price_per_month');
                    return;
                }
                if (this.monthlyPriceToggle) {
                    const mp = this.propertyData.monthlyPrice;
                    // if (!mp) return this.regMsgTextErr = this.$t('validation.add_price_per_month');

                    const num = Number(mp);
                    if (!Number.isInteger(num) || num <= 0) {
                        return this.regMsgTextErr = this.$t('validation.price_must_be_integer');
                    }
                }

                if (this.propertyData.price > this.maxPropertyPrice) {
                    
                    this.propertyData.priceAmount = `${this.$t('validation.price_limit')} ${this.maxPropertyPrice} ${this.$t('validation.or_less')}`;
                    return;
                }
                // if (this.propertyData.monthlyPrice > this.maxMonthlyPrice) {
                //     this.regMsgTextErr = `${this.$t('validation.price_limit')} ${this.maxMonthlyPrice} ${this.$t('validation.or_less')}`;
                //     return;
                // }
                if (this.discountToggle) {
                    const discountStartDate = this.dateRangeStart.startDate;
                    const discountEndDate = this.dateRangeEnd.startDate;
                    this.propertyData.discountsdate = discountStartDate;
                    this.propertyData.discountedate = discountEndDate;


                    if (!this.propertyData.discountpersentage) {
                        // this.regMsgTextErr = 'Please select a discount percentage';
                        this.regMsgTextErr = this.$t('validation.select_discount_percentage');
                        return;
                    }

                    if (!this.propertyData.discountsdate || !this.propertyData.discountedate) {
                        this.regMsgTextErr = this.$t('validation.select_discount_dates');
                        return;
                    }

                    if (discountStartDate > discountEndDate) {
                        this.regMsgTextErr = this.$t('validation.discount_start_after_end');
                        return;
                    }

                    const diffInDays = Math.ceil((discountEndDate - discountStartDate) / (1000 * 60 * 60 * 24));
                    if (diffInDays > 14) {
                        this.regMsgTextErr = this.$t('validation.discount_duration_limit');
                        return;
                    }
                }

                if (this.flashdiscountToggle) {
                    const flashstartDate = this.dateRangeFlash.startDate;
                    this.propertyData.flashstartDate = flashstartDate;
                    if (!this.propertyData.flashdiscountPercentage) {
                        this.regMsgTextErr = this.$t('validation.select_flash_discount_percentage');
                        return;
                    }

                    if (!this.propertyData.flashstartDate) {
                        this.regMsgTextErr = this.$t('validation.select_flash_discount_start_date');
                        return;
                    }
                }
                if (this.monthlyflashdiscountToggle) {
                    const flashstartDateMonthly = this.dateRangeMonthly.startDate;
                    this.propertyData.monthlyFlashstartDate = flashstartDateMonthly;
                    if (!this.propertyData.monthlyPrice) {
                        this.regMsgTextErr = this.$t('validation.select_monthly_price');
                        return;
                    }

                    if (!this.propertyData.monthlyFlashstartDate) {
                        this.regMsgTextErr = this.$t('validation.select_monthly_flash_discount_start_date');
                        return;
                    }
                }

                this.currStep = 10;
                this.regBtnText = this.$t('register.next');
            } else if (this.currStep == 10) {
                if (!this.propertyData.min_age) {
                    this.regMsgTextErr = this.$t('validation.add_min_age_to_rent');
                    return;
                } else if (this.propertyData.min_age < 18) {
                    this.regMsgTextErr = this.$t('validation.min_age_limit');
                    return;
                }
                if (!this.propertyData.children) {
                    this.regMsgTextErr = this.$t('validation.add_children_info');
                    return;
                }
                if (!this.propertyData.Events) {
                    this.regMsgTextErr = this.$t('validation.add_events_info');
                    return;
                }
                if (!this.propertyData.Pets) {
                    this.regMsgTextErr = this.$t('validation.add_pets_info');
                    return;
                }
                if (!this.propertyData.Smoking) {
                    // this.regMsgTextErr = 'Please add information about smoking';
                    this.regMsgTextErr = this.$t('validation.add_smoking_info');
                    return;
                }
                
                if (this.propertyData.price > this.maxPropertyPrice) {
                    // this.propertyData.priceAmount = `Price must be ${this.maxPrice} or less`;
                    this.propertyData.priceAmount = `${this.$t('validation.price_limit')} ${this.maxPropertyPrice} ${this.$t('validation.or_less')}`;
                    return;
                }
                this.currStep = 11;
                this.regBtnText = this.$t('register.next');
            } else if (this.currStep == 11) {
                if (!this.propertyData.city) {
                    this.regMsgTextErr = this.$t('validation.add_city');
                    return;
                }
                if (localStorage.getItem('region') == 'United States' && !this.propertyData.state) {
                    this.regMsgTextErr = this.$t('validation.add_state');
                    return;
                }
                if (!this.propertyData.country) {
                    this.regMsgTextErr = this.$t('validation.add_country');
                    return;
                }
                if (!this.propertyData.address) {
                    this.regMsgTextErr = this.$t('validation.add_address');
                    return;
                }
                if (!this.propertyData.postal_code) {
                    this.regMsgTextErr = this.$t('validation.add_postal_code');
                    return;
                }
                const formattedAddress = [
                    this.propertyData.address,
                    this.propertyData.postal_code,
                    this.propertyData.city,
                    this.propertyData.state,
                    this.propertyData.country
                ]
                    .filter(part => part)
                    .join(', ');
                const formattedAddress1 = '2930 Pearl Street Suite 100, Boulder, CO 80301-1124, USA'
                this.validateAddress(formattedAddress);
                setTimeout(() => {
                    if (this.validaddress == false) {
                        this.regMsgTextErr = this.$t('validation.invalid_address');
                        return;
                    }
                    this.currStep = 12;
                }, 500);
                this.regBtnText = this.$t('register.next');
            } else if (this.currStep == 12) {
                // this.currStep = 14;
                // this.regBtnText = this.$t('register.next');
                this.regBtnText = this.$t('register.next');
            }
            // else if (this.currStep == 14) {
            //     this.regBtnText = this.$t('register.next');
            // }
            this.saveState();
        },
        async previewImages(event) {
            const files = event.target.files || event.dataTransfer.files;
            if (files) {
                this.isImageValidating = true;
                try {
                    for (let i = 0; i < files.length; i++) {
                        const file = files[i];
                        if (file) {
                            const isValid = await this.validateImage(file);
                            if (!isValid) {
                                this.regMsgTextErr = this.$t('validations.invalid_image');
                                continue; // Skip invalid images
                            }
                            const reader = new FileReader();
                            reader.onload = (e) => {
                                this.propertyData.imagePreviews.push(e.target.result);
                                this.$forceUpdate();
                            };
                            reader.readAsDataURL(file);
                        }
                    }
                } finally {
                    this.isImageValidating = false;
                    // Reset the file input to allow uploading the same file again
                    event.target.value = '';
                }
            }
        },

        async validateImage(file) {
            return new Promise((resolve) => {
                const img = new Image();
                img.src = URL.createObjectURL(file);
                img.onload = async () => {
                    try {
                        const model = await mobilenet.load();
                        const predictions = await model.classify(img);
                        // Comprehensive list of property-related keywords
                        const propertyKeywords = [
                            // Building types
                            "house", "apartment", "building", "palace", "mansion", "villa", "cottage", "bungalow", "duplex",
                            "townhouse", "condo", "condominium", "flat", "studio", "loft", "penthouse", "castle", "church",
                            "temple", "mosque", "cathedral", "monastery", "chapel", "shrine", "basilica", "tower", "skyscraper",

                            // Architectural elements
                            "architecture", "facade", "roof", "tile roof", "terrace", "balcony", "porch", "patio", "deck",
                            "garden", "yard", "courtyard", "fence", "gate", "door", "window", "wall", "column", "arch",

                            // Property-related terms
                            "real estate", "property", "residence", "dwelling", "home", "housing", "construction", "structure",
                            "edifice", "premises", "estate", "landmark", "monument", "heritage", "historic", "modern",

                            // Location indicators
                            "residential", "commercial", "industrial", "urban", "suburban", "rural", "neighborhood", "district",
                            "community", "development", "complex", "compound", "campus", "park", "plaza", "square"
                        ];

                        // Function to check if a prediction matches any keyword using fuzzy matching
                        const isPropertyRelated = (prediction) => {
                            const predictionText = prediction.className.toLowerCase();
                            const confidence = prediction.probability;
                            if (confidence > 0.5) {
                                // Split prediction into words and check if any word is in our keywords
                                const predictionWords = predictionText.split(/\s+/);
                                if (predictionWords.some(word => propertyKeywords.includes(word))) {
                                    return true;
                                }
                            }

                            // For lower confidence, use stricter matching

                            // Check for exact matches
                            if (propertyKeywords.some(keyword => predictionText === keyword.toLowerCase())) {
                                return true;
                            }

                            // Check for partial matches (e.g., "church building" contains "church")
                            if (propertyKeywords.some(keyword => predictionText.includes(keyword.toLowerCase()))) {
                                return true;
                            }

                            // Check for similar terms (e.g., "residential building" is similar to "residence")
                            return propertyKeywords.some(keyword => {
                                const keywordWords = keyword.toLowerCase().split(' ');
                                return keywordWords.some(word => predictionText.includes(word));
                            });
                        };

                        // Check if any prediction is property-related
                        const isValid = predictions.some(isPropertyRelated);
                        resolve(isValid);
                    } catch (error) {
                        console.error('Error validating image:', error);
                        resolve(false);
                    }
                };
            });
        },
        removeImage(index) {
            this.propertyData.imagePreviews.splice(index, 1);
            this.$forceUpdate();
        },
        handleDrop(event) {
            event.preventDefault();
            this.previewImages(event);
        },
        toggleAudience(key, event) {
            if (!Array.isArray(this.propertyData.targetaudience)) {
                this.propertyData.targetaudience = [];
            }

            if (event.target.checked) {
                // add if not present
                if (!this.propertyData.targetaudience.includes(key)) {
                    this.propertyData.targetaudience.push(key);
                }
            } else {
                // remove if unchecked
                this.propertyData.targetaudience = this.propertyData.targetaudience.filter(
                    item => item !== key
                );
            }
        },
        addProperty() {
            this.$v.propertyData.$touch();
            this.isDisabled = true;
            this.isLoading = true; // Start loading
            if (this.propertyData.price != null && this.propertyData.monthlyPrice != null) {
                if (this.monthlyPriceToggle) {
                    this.propertyData.price = null;
                } else if (this.nightPriceToggle) {
                    this.propertyData.monthlyPrice = null;
                }
            }
            if (this.propertyData.id) {
                API.updateProperty(this.propertyData, data => {
                    this.isLoading = false; // Stop loading
                    this.isDisabled = false;
                    if (data.status == 200) {
                        this.resetForm();
                        this.$swal({
                            icon: 'success',
                            type: 'success',
                            title: this.$t('alerts.success'),
                            text: this.$t('sweetalert.property_update_message'),
                            confirmButtonText: this.$t('sweetalert.OK'),
                        });
                        this.$router.push({ name: 'properties' });
                    } else {
                        this.$swal({
                            icon: 'error',
                            type: 'error',
                            title: this.$t('sweetalert.Oops'),
                            text: data.message,
                            confirmButtonText: this.$t('sweetalert.OK'),
                        })
                    }
                }, error => {
                    this.isLoading = false; // Stop loading on error
                    console.error('Error callback not provided or invalid:', error);
                });
            } else {
                API.addProperty(this.propertyData, data => {
                    this.isLoading = false; // Stop loading
                    this.isDisabled = false;
                    if (data.status == 200) {
                        this.resetForm();
                        if (this.$route.path == '/add_property') {
                            this.$swal({
                                icon: 'success',
                                type: 'success',
                                title: this.$t('alerts.success'),
                                text: this.$t('sweetalert.property_added_message'),
                                confirmButtonText: this.$t('sweetalert.OK'),
                            });
                            this.$router.push({ name: 'home' });
                        } else {
                            this.$router.push({ name: 'properties' });
                        }
                    } else {
                        this.$swal({
                            icon: 'error',
                            type: 'error',
                            title: this.$t('sweetalert.Oops'),
                            text: data.message,
                            confirmButtonText: this.$t('sweetalert.OK'),
                        })
                    }
                }, error => {
                    this.isLoading = false; // Stop loading on error
                    console.error('Error callback not provided or invalid:', error);
                });
            }
        },
        editProperty(id) {
            if (id != null) {
                API.editProperty(id, res => {
                    this.propertyData = res.data.data;
                    if (res.data.discounts != null) {
                        // this.longstaysToggle = true;  // Directly update longstaysToggle
                        this.propertyData.oneweekdisc = res.data.discounts.oneweekdisc;
                        this.propertyData.twoweekdisc = res.data.discounts.twoweekdisc;
                        this.propertyData.threeweekdisc = res.data.discounts.threeweekdisc;
                        //set longstays toggle
                        this.longstaysToggle = !!(this.propertyData.oneweekdisc || this.propertyData.twoweekdisc || this.propertyData.threeweekdisc);
                        this.propertyData.onemonthdis = res.data.discounts.onemonthdis;
                        this.propertyData.twomonthsdis = res.data.discounts.twomonthsdis;
                        this.propertyData.threemonthsdis = res.data.discounts.threemonthsdis;
                        this.propertyData.fourmonthsdis = res.data.discounts.fourmonthsdis;

                        //set monthly mediun toggle
                        this.shortMonthstaysToggle = !!(this.propertyData.onemonthdis || this.propertyData.twomonthsdis || this.propertyData.threemonthsdis || this.propertyData.fourmonthsdis);
                        this.propertyData.fivemonthsdis = res.data.discounts.fivemonthsdis;
                        this.propertyData.sixmonthsdis = res.data.discounts.sixmonthsdis;
                        this.propertyData.sevenmonthsdis = res.data.discounts.sevenmonthsdis;
                        this.propertyData.eightmonthsdis = res.data.discounts.eightmonthsdis;
                        //set monthly mediun toggle
                        this.longMonthstaysToggle = !!(this.propertyData.fivemonthsdis || this.propertyData.sixmonthsdis || this.propertyData.sevenmonthsdis || this.propertyData.eightmonthsdis);


                    } else {
                        this.longstaysToggle = false;  // Ensure it's set to false if no discounts
                    }
                    if (res.data.flashdiscount != null) {
                        this.flashdiscountToggle = true;  // Directly update longstaysToggle
                        this.propertyData.flashdiscountPercentage = res.data.flashdiscount.discount_percentage;
                        const flashDate = new Date(res.data.flashdiscount.start_date);
                        const formattedDate = this.formatDate(flashDate);
                        // Assign the formatted date to the property
                        this.propertyData.flashstartDate = formattedDate;
                    } else {
                        this.flashdiscount = false;  // Ensure it's set to false if no discounts
                    }
                    this.propertyData.imagePreviews = res.data.data.photos;
                    this.propertyData.propertyType = res.data.data.property_type;
                    this.propertyData.placeType = res.data.data.place_type;
                    try {
                        if (typeof res.data.data.target_audience === "string") {
                            this.propertyData.targetaudience = JSON.parse(res.data.data.target_audience);
                        } else {
                            this.propertyData.targetaudience = res.data.data.target_audience || [];
                        }
                    } catch (e) {
                        this.propertyData.targetaudience = [];
                    }
                    // this.propertyData.targetaudience = res.data.data.target_audience;
                    this.propertyData.accomodationType = res.data.data.accommodation_type;
                    this.propertyData.wifiAvailable = res.data.data.wifi_available ? 1 : 0;
                    this.propertyData.price = res.data.data.price;
                    this.propertyData.monthlyPrice = res.data.data.price_per_month;
                    // this.monthlyPriceToggle = true;

                    if (this.propertyData.min_night_stay != null && this.propertyData.max_night_stay != null) {
                        const minUnitValue = this.convertNightsToUnit(this.propertyData.min_night_stay);
                        this.minStay = minUnitValue.value;
                        this.minStayUnit = minUnitValue.unit;

                        const maxUnitValue = this.convertNightsToUnit(this.propertyData.max_night_stay);
                        this.maxStay = maxUnitValue.value;
                        this.maxStayUnit = maxUnitValue.unit;
                        // set min duration
                        // const minUnitValue = this.convertNightsToUnit(this.propertyData.min_night_stay);
                        // this.minStay = minUnitValue.value;
                        // this.minStayUnit = minUnitValue.unit;

                        // // set max duration
                        // const maxUnitValue = this.convertNightsToUnit(this.propertyData.max_night_stay);
                        // this.maxStay = maxUnitValue.value;
                        // this.maxStayUnit = maxUnitValue.unit;
                        // this.handleStayChange();
                    }
                    this.propertyData.kitchen = res.data.data.kitchen_available ? 1 : 0;
                    this.propertyData.tv = res.data.data.tv_available ? 1 : 0;
                    this.propertyData.lang = this.$i18n.locale;
                    this.propertyData.description = res.data.data.property_description;

                    if (typeof this.propertyData.bathroom_Amenities === 'string') {
                        this.propertyData.bathroom_Amenities = JSON.parse(this.propertyData.bathroom_Amenities);
                    }
                    if (Array.isArray(this.propertyData.bathroom_Amenities)) {
                        this.propertyData.bathroom_Amenities.forEach(amenity => {
                            if (amenity === "Soap") {
                                this.propertyData.soapAvailable = true;
                            } else if (amenity === "Shower_only") {
                                this.propertyData.showerOnly = true;
                            } else if (amenity === "Towels_provided") {
                                this.propertyData.towelsProvided = true;
                            } else if (amenity === "Shampoo") {
                                this.propertyData.shampooAvailable = true;
                            } else if (amenity === "Toilet") {
                                this.propertyData.toiletAvailable = true;
                            }
                        });
                    }
                    if (typeof this.propertyData.bedroom_Amenities === 'string') {
                        this.propertyData.bedroom_Amenities = JSON.parse(this.propertyData.bedroom_Amenities);
                    }
                    if (Array.isArray(this.propertyData.bedroom_Amenities)) {
                        this.propertyData.bedroom_Amenities.forEach(amenity => {
                            if (amenity === "King_Bed") {
                                this.propertyData.bedroom_Amenities.King_Bed = true;
                            } else if (amenity === "Double_Sofa_Bed") {
                                this.propertyData.bedroom_Amenities.Double_Sofa_Bed = true;
                            } else if (amenity === "Double_Futon") {
                                this.propertyData.bedroom_Amenities.Double_Futon = true;
                            }
                        });
                    }
                }, err => {
                    console.log(err);
                })
            }
        },
        formatDate(date) {
            return moment(date).format('DD-MM-YYYY');
        },
        async validateAddress(addressInput) {
            const url = `/api/validate-address?address=${encodeURIComponent(addressInput)}`;

            try {
                const response = await fetch(url);
                if (!response.ok) {
                    const text = await response.text();
                    console.error(`HTTP Error ${response.status}:`, text);
                    this.validaddress = false;
                    return;
                }
                let data;
                try {
                    data = await response.json();
                } catch (jsonError) {
                    const text = await response.text();
                    console.error("Response not JSON. Raw response:", text);
                    this.validaddress = false;
                    return;
                }
                if (data.status === "OK" && data.results?.length > 0) {
                    const result = data.results[0];
                    const components = result.address_components || [];

                    let hasStreet = false;
                    let city = "";
                    let country = "";

                    components.forEach(c => {
                        if (c.types.includes("street_number") || c.types.includes("route")) {
                            hasStreet = true;
                        }
                        if (
                            c.types.includes("locality") ||
                            c.types.includes("administrative_area_level_1") ||
                            c.types.includes("postal_town")
                        ) {
                            city = c.long_name;
                        }
                        if (c.types.includes("country")) {
                            country = c.long_name;
                        }
                    });

                    if (hasStreet && city && country) {
                        this.validaddress = true;
                    } else {
                        this.validaddress = false;
                        console.warn("Incomplete address: missing street/city/country.");
                    }
                } else {
                    this.validaddress = false;
                    console.warn("Address validation failed:", data.status);
                }
            } catch (error) {
                console.error("Error during backend API call:", error);
                this.validaddress = false;
            }
        },
        async loadPlacesService() {
            const loader = new Loader({
                apiKey: process.env.VUE_APP_GOOLE_PLACES_API_KEY,
                version: 'weekly',
                libraries: ['places']
            });
            try {
                await loader.load();
                this.placesService = new window.google.maps.places.AutocompleteService();
            } catch (error) {
                console.error('Error loading Google Maps API:', error);
            }
        },
        onInput() {
            if (this.propertyData.address.length < 3) {
                this.suggestions = [];
                return;
            }

            if (!this.placesService) {
                console.error('PlacesService is not initialized');
                return;
            }
            this.placesService.getPlacePredictions(
                { input: this.propertyData.address, types: ['geocode'] },
                (predictions, status) => {
                    if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                        this.suggestions = predictions;
                    } else {
                        console.error('Error fetching place predictions:', status);
                        this.suggestions = [];
                    }
                }
            );
        },
        selectSuggestion(suggestion) {
            this.propertyData.address = suggestion.description;
            this.suggestions = [];
        },
        loadState() {
            const id = this.$route.params.id;
            if (id) {
                const savedPropertyId = localStorage.getItem('propertyId');
                if (savedPropertyId === id) {
                    const savedStep = localStorage.getItem('currStep');
                    const savedData = localStorage.getItem('propertyData');
                    if (savedStep) {
                        this.currStep = parseInt(savedStep);
                    }
                    if (savedData) {
                        this.propertyData = JSON.parse(savedData);
                    }
                } else {
                    this.resetForm();
                }
            } else {
                const savedStep = localStorage.getItem('newPropertyStep');
                const savedData = localStorage.getItem('newPropertyData');
                if (savedStep) {
                    this.currStep = parseInt(savedStep);
                }
                if (savedData) {
                    this.propertyData = JSON.parse(savedData);
                }
            }
        },
        saveState() {
            const id = this.$route.params.id;
            if (id) {
                localStorage.setItem('propertyId', id);
                localStorage.setItem('currStep', this.currStep);
                localStorage.setItem('propertyData', JSON.stringify(this.propertyData));
            } else {
                localStorage.setItem('newPropertyStep', this.currStep);
                localStorage.setItem('newPropertyData', JSON.stringify(this.propertyData));
            }
        },
        resetForm() {
            this.currStep = 1;
            this.propertyData = {
                lang: "en",
                city: "",
                state: "",
                country: "",
                address: "",
                postal_code: "",
                price: "",
                discountpersentage: "",
                flashdiscountPercentage: "",
                monthlyflashdiscountPercentage: "",
                oneweekdisc: "",
                twoweekdisc: "",
                threeweekdisc: "",
                onemonthdis: "",
                twomonthsdis: "",
                threemonthsdis: "",
                fourmonthsdis: "",
                fivemonthsdis: "",
                sixmonthsdis: "",
                sevenmonthsdis: "",
                eightmonthsdis: "",
                discountsdate: "",
                discountedate: "",
                flashstartDate: "",
                monthlyFlashstartDate: "",
                priceAmount: "",
                max_guests: "",
                min_guests: "",
                num_bedrooms: "",
                num_bathrooms: "",
                min_age: "",
                propertyType: "",
                accomodationType: "",
                placeType: "",
                targetaudience: "",
                children: "",
                Events: "",
                Pets: "",
                Smoking: "",
                wifiAvailable: null,
                kitchen: null,
                tv: null,
                king_size_bed: 0,
                queen_size_bed: 0,
                sofa_bed: 0,
                description: "",
                imagePreviews: [],
                bathroom_Amenities: [],
                bedroom_Amenities: [],
                id: "",
                currency: 'USD',
                monthlyPrice: "",
                min_night_stay: 1,
                max_night_stay: 7,
            };

            // Clear both new property and editing states
            localStorage.removeItem('newPropertyStep');
            localStorage.removeItem('newPropertyData');
            localStorage.removeItem('propertyId');
            localStorage.removeItem('currStep');
            localStorage.removeItem('propertyData');
        },


    },
    computed: {
        translatedPropertyTypeOptions() {
            const translatedOptions = {};
            for (const key in this.propertyTypeOptions) {
                translatedOptions[key] = this.$t(`property_detail.${key}`);
            }
            return translatedOptions;
        },
        translatedyesnoOptions() {
            const translatedOptions = {};
            for (const key in this.yesNoOptions) {
                translatedOptions[key] = this.$t(`property_detail.${key}`);
            }
            return translatedOptions;
        },
        // New ones following the same pattern for consistency
        translatedCurrencyOptions() {
            return this.currencyOptions.map(option => ({
                ...option,
                text: this.$t(`currencies.${option.value}`)
            }));
        },
        translatedPlaceTypeOption() {
            const translatedOptions = {};
            for (const key in this.placeTypeOption) {
                translatedOptions[key] = this.$t(`property_detail.place_types.${key}`);
            }
            return translatedOptions;
        },
        translatedTargetaudienceOption() {
            const translatedOptions = {};
            for (const key in this.targetaudienceOption) {
                translatedOptions[key] = this.$t(`property_detail.target_audience.${key}`);
            }
            return translatedOptions;
        },
        translatedAccomodationTypeOptions() {
            const translatedOptions = {};
            for (const key in this.accomodationTypeOptions) {
                translatedOptions[key] = this.$t(`property_detail.accommodation_types.${key}`);
            }
            return translatedOptions;
        },
        translatedChildrens() {
            return Object.keys(this.childrens).map(key => ({
                key,
                label: this.$t(`Propertis.Policies.Children.${key}`)
            }));
        },
        translatedEvents() {
            return Object.keys(this.Events).map(key => ({
                key,
                label: this.$t(`Propertis.Policies.Events.${key}`)
            }));
        },
        translatedPets() {
            return Object.keys(this.Pets).map(key => ({
                key,
                label: this.$t(`Propertis.Policies.Pets.${key}`)
            }));
        },
        translatedSmoking() {
            return Object.keys(this.Smoking).map(key => ({
                key,
                label: this.$t(`Propertis.Policies.Smoking.${key}`)
            }));
        }
    },
    mounted() {
        const id = this.$route.params.id;
        if (id) {
            // For editing: load property data and state
            this.editProperty(id);
            this.loadState();
        } else {
            // For new property: load new property state
            this.loadState();
        }
        API.getAllCountries(data => {
            this.countries = data.data;
        }, error => {
            console.log(error);
        });
        this.loadPlacesService();
        this.getMaxPropertyPrice();
    },
    watch: {
        // Add route watcher
        '$route': {
            immediate: true,
            handler(to, from) {
                // If navigating from edit to new property
                if (from && from.params.id && !to.params.id) {
                    this.resetForm();
                }
                // If navigating from new to edit property
                else if (from && !from.params.id && to.params.id) {
                    this.editProperty(to.params.id);
                    this.loadState();
                }
                // If navigating between different properties
                else if (from && from.params.id !== to.params.id) {
                    this.editProperty(to.params.id);
                    this.loadState();
                }
            }
        },
        '$i18n.locale': function (newLocale, oldLocale) {
            this.propertyData.lang = this.$i18n.locale;
        }
    },

    beforeRouteLeave(to, from, next) {
        // Save state before leaving the route
        this.saveState();
        next();
    },

    beforeRouteUpdate(to, from, next) {
        // Handle route updates (like changing property ID)
        if (from.params.id !== to.params.id) {
            this.editProperty(to.params.id);
            this.loadState();
        }
        next();
    },
}
</script>

<style></style>

<style>
.form-switch .form-check-input {
    top: -30px;
    left: 0;
}

.left-card.m-b-30 {
    display: flex;
    align-items: center;
    justify-content: center;
    height: auto;
}

.checkbox-group .custom-control-label {
    padding-top: 5px !important;
}

.custom-label {
    font-size: 0.875rem;
}

.checkbox-group .b-form-checkbox {
    display: inline-flex;
    align-items: center;
    margin-right: 10px;
    vertical-align: middle;
}

.Customer-card-body {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
}

.Customer-card-body .card {
    border: 0;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 0 6px 5px #0000000f;
}

.Customer-card-body .card .card-heading h5 {
    margin: 0;
    font-size: 20px;
    line-height: 1.2;
    color: #fff;
}

.Customer-card-body .card-body {
    border: 0;
    border-radius: 0;
    padding: 20px;
}

.Customer-card-body .card-body .form-group .form-check {
    margin-top: 0;
    margin-bottom: 15px;
    width: 32%;
    padding-left: 20px;
    margin-right: 5px;
}

.Customer-card-body .card-body .form-group .radio-buttons-wrapper {
    padding-left: 0 !important;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}

.Customer-card-body .card .card-heading {
    margin-bottom: 0;
    background: #70D3FF;
    padding: 20px;
}

.footer-buttons.md-form {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.footer-buttons.md-form .btn.btn-default {
    border: 1px solid #B6B6B6;
    background: #B6B6B6;
    width: 105px;
    color: #fff;
    margin-right: 15px;
    font-weight: 500;
    border-radius: 5px;
    height: 44px;
}

.footer-buttons.md-form .btn.btn-default:hover {
    background: #70d3ff;
    border-color: #70d3ff;
    color: #fff;
}

.footer-buttons.md-form .btn.btn-primary {
    border-radius: 5px !important;
    box-shadow: none !important;
    height: 44px;
    margin-left: auto !important;
}

.Customer-card-body .card.second-step .card-body .form-group {
    margin: 0;
}

.Customer-card-body .card.second-step .card-body .form-group .radio-buttons-wrapper {
    padding-left: 0;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
}

.Customer-card-body .card.second-step .card-body .form-group .radio-buttons-wrapper label.form-check-label {
    margin-left: 0;
    color: #717171;
    font-size: 16px;
}

.Customer-card-body .card.second-step .card-body .form-group .radio-buttons-wrapper label.form-label {
    width: 100%;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 10px;
    color: #333;
}

.Customer-card-body .card.second-step .card-body .form-group .form-check {
    width: 70px;
    padding-left: 20px;
}

.Customer-card-body .card-body .form-group .form-control {
    border-radius: 10px;
    border: 1px solid #D6D6D6;
}

.Customer-card-body .card-body .form-group .checkbox-group .form-check .form-check-label {
    margin: 0 0 0 0.75rem;
}

.Customer-card-body .card-body .form-group .checkbox-group .form-check {
    padding-left: 20px;
    width: 100%;
}

.Customer-card-body .card-body .form-group .checkbox-group .custom-label {
    font-weight: 600;
    color: #333;
    font-size: 16px;
}

.Customer-card-body .amenities-form .form-group {
    width: 48%;
}

.Customer-card-body .card-body.md-form.amenities-form {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    column-gap: 10px;
}

.Customer-card-body .card-body.step-five .form-group label {
    display: block;
    font-weight: 500;
    margin-bottom: 10px;
}

.Customer-card-body .card-body.step-five .form-group {
    margin: 0;
}

.images-listing {
    display: flex;
    flex-wrap: wrap;
    gap: 22px;
}

.images-listing .images-card {
    margin-top: 15px;
    width: auto;
    position: relative;
}

.images-listing .images-card img {
    border-radius: 15px;
    width: 120px;
    height: 120px;
    object-fit: cover;
    border: 1px solid #ddd;
}

.images-listing .images-card button.btn {
    width: 26px !important;
    margin-top: 0 !important;
    border-radius: 100px !important;
    height: 26px;
    padding: 0 !important;
    font-size: 10px !important;
    box-shadow: none !important;
    position: absolute;
    right: -10px;
    top: -10px;
    background: #70d3ff !important;
}

.images-listing .images-card button.btn svg {
    width: 12px;
}

.Customer-card-body .card-body.step-five.addProperty .form-group input[type=file] {
    opacity: 0;
    width: 0;
    height: 0;
    display: none;
}

.Customer-card-body .card-body.step-five .form-group .upload-img {
    flex-wrap: wrap;
    border: 2px dotted #70D3FF;
    border-radius: 15px;
    text-align: center;
    max-width: 500px;
    margin: 10px auto;
    gap: 25px;
    padding: 25px;
}

.Customer-card-body .card-body.step-five .form-group .upload-img .image {
    width: 100%;
}

.Customer-card-body .card-body.step-five .form-group .upload-img label {
    margin-right: 0;
    border: none;
    background: #70d3ff;
    padding: 10px 20px;
    border-radius: 10px;
    color: #fff;
    cursor: pointer;
    transition: background .2s ease-in-out;
    width: 100%;
    margin: 0;
    max-width: 150px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
}

.Customer-card-body .card-body.step-five .form-group .upload-img p {
    width: 100%;
    color: #717171;
    font-size: 16px;
    line-height: 1.2;
}

.Customer-card-body .card-body .form-group textarea.form-control {
    padding: 10px;
    height: 150px;
    border-radius: 10px;
}

.Customer-card-body .card.laststep {
    border: 0;
    border-radius: 10px;
    padding: 40px 20px;
    text-align: center;
}

.Customer-card-body .card-body .form-group label {
    font-weight: 500;
    color: #717171;
    font-size: 16px;
}

.Customer-card-body .card-body .form-group label .text-red {
    color: red;
}

.guest-content {
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    margin-bottom: 15px;
    border-right: 0 !important;
}

.guest-content:last-child {
    margin-bottom: 0;
}

.guest-content .btn.btn-info {
    padding: 0;
    width: auto;
    height: auto;
    font-size: 24px;
    background: transparent;
    border: 0;
    color: #D9D9D9;
    border-radius: 0;
}

.guest-content .form-control {
    padding: 0;
    height: 30px;
    border: 0;
    text-align: center;
    width: 60px;
    appearance: none;
}

.guest-content .form-control::-webkit-outer-spin-button,
.guest-content .form-control::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.form-group.quality-fileds {
    display: flex;
    align-items: center;
    gap: 25px;
}

.form-group.quality-fileds .guest-content {
    margin: 0;
    gap: 6px;
    flex-wrap: wrap;
}

.form-group.quality-fileds .guest-content .input-group {
    gap: 0;
    border: 1px solid #D6D6D6;
    border-radius: 10px;
    overflow: hidden;
    padding: 6px 10px;
    flex-wrap: nowrap;
}

.form-group.quality-fileds .guest-content label {
    margin: 0;
    width: 100%;
    color: #717171;
    font-size: 16px;
}

.Customer-card-body .card-body .form-group .quantity .form-control {
    border: 0;
}

.validation-loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-top: 15px;
}

.validation-loader p {
    color: #717171;
    font-size: 14px;
    margin: 0;
}

.upload-img {
    border: 2px dashed #ccc;
    padding: 20px;
    text-align: center;
    cursor: pointer;
}

.upload-img:hover {
    border-color: #aaa;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.spinner-border {
    width: 3rem;
    height: 3rem;
}

/* Remove the full screen loading overlay styles */
.loading-overlay {
    display: none;
}

/* Add button loading styles */
.btn-primary.list-property {
    min-width: 150px;
    position: relative;
}

.btn-primary.list-property:disabled {
    opacity: 0.8;
    cursor: not-allowed;
}

.btn-primary.list-property .fa-spinner {
    margin-right: 8px;
}

/* Fix the linter error */
.Customer-card-body .card-body .form-group .checkbox-group .custom-label {
    font-weight: 600;
    color: #333;
    font-size: 16px;
}

.text-danger {
    padding-top: 5px;
    display: block;
    font-size: 14px;
}


@media (max-width: 575px) {
    .Customer-card-body .card-body .form-group .form-check {
        width: 48%;
    }

    .images-listing {
        justify-content: center;
    }

    .Customer-card-body .card .card-heading h5 {
        font-size: 18px;
    }
}

@media (max-width: 450px) {
    .form-group.quality-fileds {
        flex-wrap: wrap;
    }

    .form-group.quality-fileds .guest-content {
        width: 45% !important;
    }
}

@media (max-width: 389px) {

    .Customer-card-body .card-body .form-group .form-check,
    .Customer-card-body .amenities-form .form-group {
        width: 100%;
    }
}
</style>